// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/photoswipe/dist/photoswipe.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Foundation for Sites
 * Version 6.9.0
 * https://get.foundation
 * Licensed under MIT Open Source
 */
.grid-container {
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-container {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.grid-container.fluid {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-container.fluid {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.grid-container.full {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-right: 0;
  padding-left: 0;
}

.grid-x {
  display: flex;
  flex-flow: row wrap;
}

.cell {
  flex: 0 0 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}
.cell.auto {
  flex: 1 1 0;
}
.cell.shrink {
  flex: 0 0 auto;
}

.grid-x > .auto {
  width: auto;
}
.grid-x > .shrink {
  width: auto;
}

.grid-x > .small-shrink, .grid-x > .small-full, .grid-x > .small-1, .grid-x > .small-2, .grid-x > .small-3, .grid-x > .small-4, .grid-x > .small-5, .grid-x > .small-6, .grid-x > .small-7, .grid-x > .small-8, .grid-x > .small-9, .grid-x > .small-10, .grid-x > .small-11, .grid-x > .small-12 {
  flex-basis: auto;
}

@media print, screen and (min-width: 40em) {
  .grid-x > .medium-shrink, .grid-x > .medium-full, .grid-x > .medium-1, .grid-x > .medium-2, .grid-x > .medium-3, .grid-x > .medium-4, .grid-x > .medium-5, .grid-x > .medium-6, .grid-x > .medium-7, .grid-x > .medium-8, .grid-x > .medium-9, .grid-x > .medium-10, .grid-x > .medium-11, .grid-x > .medium-12 {
    flex-basis: auto;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-x > .large-shrink, .grid-x > .large-full, .grid-x > .large-1, .grid-x > .large-2, .grid-x > .large-3, .grid-x > .large-4, .grid-x > .large-5, .grid-x > .large-6, .grid-x > .large-7, .grid-x > .large-8, .grid-x > .large-9, .grid-x > .large-10, .grid-x > .large-11, .grid-x > .large-12 {
    flex-basis: auto;
  }
}
.grid-x > .small-12, .grid-x > .small-11, .grid-x > .small-10, .grid-x > .small-9, .grid-x > .small-8, .grid-x > .small-7, .grid-x > .small-6, .grid-x > .small-5, .grid-x > .small-4, .grid-x > .small-3, .grid-x > .small-2, .grid-x > .small-1 {
  flex: 0 0 auto;
}

.grid-x > .small-1 {
  width: 8.3333333333%;
}

.grid-x > .small-2 {
  width: 16.6666666667%;
}

.grid-x > .small-3 {
  width: 25%;
}

.grid-x > .small-4 {
  width: 33.3333333333%;
}

.grid-x > .small-5 {
  width: 41.6666666667%;
}

.grid-x > .small-6 {
  width: 50%;
}

.grid-x > .small-7 {
  width: 58.3333333333%;
}

.grid-x > .small-8 {
  width: 66.6666666667%;
}

.grid-x > .small-9 {
  width: 75%;
}

.grid-x > .small-10 {
  width: 83.3333333333%;
}

.grid-x > .small-11 {
  width: 91.6666666667%;
}

.grid-x > .small-12 {
  width: 100%;
}

@media print, screen and (min-width: 40em) {
  .grid-x > .medium-auto {
    flex: 1 1 0;
    width: auto;
  }
  .grid-x > .medium-12, .grid-x > .medium-11, .grid-x > .medium-10, .grid-x > .medium-9, .grid-x > .medium-8, .grid-x > .medium-7, .grid-x > .medium-6, .grid-x > .medium-5, .grid-x > .medium-4, .grid-x > .medium-3, .grid-x > .medium-2, .grid-x > .medium-1, .grid-x > .medium-shrink {
    flex: 0 0 auto;
  }
  .grid-x > .medium-shrink {
    width: auto;
  }
  .grid-x > .medium-1 {
    width: 8.3333333333%;
  }
  .grid-x > .medium-2 {
    width: 16.6666666667%;
  }
  .grid-x > .medium-3 {
    width: 25%;
  }
  .grid-x > .medium-4 {
    width: 33.3333333333%;
  }
  .grid-x > .medium-5 {
    width: 41.6666666667%;
  }
  .grid-x > .medium-6 {
    width: 50%;
  }
  .grid-x > .medium-7 {
    width: 58.3333333333%;
  }
  .grid-x > .medium-8 {
    width: 66.6666666667%;
  }
  .grid-x > .medium-9 {
    width: 75%;
  }
  .grid-x > .medium-10 {
    width: 83.3333333333%;
  }
  .grid-x > .medium-11 {
    width: 91.6666666667%;
  }
  .grid-x > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-x > .large-auto {
    flex: 1 1 0;
    width: auto;
  }
  .grid-x > .large-12, .grid-x > .large-11, .grid-x > .large-10, .grid-x > .large-9, .grid-x > .large-8, .grid-x > .large-7, .grid-x > .large-6, .grid-x > .large-5, .grid-x > .large-4, .grid-x > .large-3, .grid-x > .large-2, .grid-x > .large-1, .grid-x > .large-shrink {
    flex: 0 0 auto;
  }
  .grid-x > .large-shrink {
    width: auto;
  }
  .grid-x > .large-1 {
    width: 8.3333333333%;
  }
  .grid-x > .large-2 {
    width: 16.6666666667%;
  }
  .grid-x > .large-3 {
    width: 25%;
  }
  .grid-x > .large-4 {
    width: 33.3333333333%;
  }
  .grid-x > .large-5 {
    width: 41.6666666667%;
  }
  .grid-x > .large-6 {
    width: 50%;
  }
  .grid-x > .large-7 {
    width: 58.3333333333%;
  }
  .grid-x > .large-8 {
    width: 66.6666666667%;
  }
  .grid-x > .large-9 {
    width: 75%;
  }
  .grid-x > .large-10 {
    width: 83.3333333333%;
  }
  .grid-x > .large-11 {
    width: 91.6666666667%;
  }
  .grid-x > .large-12 {
    width: 100%;
  }
}
.grid-margin-x:not(.grid-x) > .cell {
  width: auto;
}

.grid-margin-y:not(.grid-y) > .cell {
  height: auto;
}

.grid-margin-x {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-x {
    margin-left: -0.9375rem;
    margin-right: -0.9375rem;
  }
}
.grid-margin-x > .cell {
  width: calc(100% - 1.25rem);
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-x > .cell {
    width: calc(100% - 1.875rem);
    margin-left: 0.9375rem;
    margin-right: 0.9375rem;
  }
}
.grid-margin-x > .auto {
  width: auto;
}
.grid-margin-x > .shrink {
  width: auto;
}
.grid-margin-x > .small-1 {
  width: calc(8.3333333333% - 1.25rem);
}
.grid-margin-x > .small-2 {
  width: calc(16.6666666667% - 1.25rem);
}
.grid-margin-x > .small-3 {
  width: calc(25% - 1.25rem);
}
.grid-margin-x > .small-4 {
  width: calc(33.3333333333% - 1.25rem);
}
.grid-margin-x > .small-5 {
  width: calc(41.6666666667% - 1.25rem);
}
.grid-margin-x > .small-6 {
  width: calc(50% - 1.25rem);
}
.grid-margin-x > .small-7 {
  width: calc(58.3333333333% - 1.25rem);
}
.grid-margin-x > .small-8 {
  width: calc(66.6666666667% - 1.25rem);
}
.grid-margin-x > .small-9 {
  width: calc(75% - 1.25rem);
}
.grid-margin-x > .small-10 {
  width: calc(83.3333333333% - 1.25rem);
}
.grid-margin-x > .small-11 {
  width: calc(91.6666666667% - 1.25rem);
}
.grid-margin-x > .small-12 {
  width: calc(100% - 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-margin-x > .auto {
    width: auto;
  }
  .grid-margin-x > .shrink {
    width: auto;
  }
  .grid-margin-x > .small-1 {
    width: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-2 {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-3 {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x > .small-4 {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-5 {
    width: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-6 {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x > .small-7 {
    width: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-8 {
    width: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-9 {
    width: calc(75% - 1.875rem);
  }
  .grid-margin-x > .small-10 {
    width: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-x > .small-11 {
    width: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-x > .small-12 {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x > .medium-auto {
    width: auto;
  }
  .grid-margin-x > .medium-shrink {
    width: auto;
  }
  .grid-margin-x > .medium-1 {
    width: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-2 {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-3 {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x > .medium-4 {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-5 {
    width: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-6 {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x > .medium-7 {
    width: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-8 {
    width: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-9 {
    width: calc(75% - 1.875rem);
  }
  .grid-margin-x > .medium-10 {
    width: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-x > .medium-11 {
    width: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-x > .medium-12 {
    width: calc(100% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-x > .large-auto {
    width: auto;
  }
  .grid-margin-x > .large-shrink {
    width: auto;
  }
  .grid-margin-x > .large-1 {
    width: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-2 {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-3 {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x > .large-4 {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-5 {
    width: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-6 {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x > .large-7 {
    width: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-8 {
    width: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-9 {
    width: calc(75% - 1.875rem);
  }
  .grid-margin-x > .large-10 {
    width: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-x > .large-11 {
    width: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-x > .large-12 {
    width: calc(100% - 1.875rem);
  }
}

.grid-padding-x .grid-padding-x {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-x .grid-padding-x {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
.grid-container:not(.full) > .grid-padding-x {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-container:not(.full) > .grid-padding-x {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
.grid-padding-x > .cell {
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-x > .cell {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}

.small-up-1 > .cell {
  width: 100%;
}

.small-up-2 > .cell {
  width: 50%;
}

.small-up-3 > .cell {
  width: 33.3333333333%;
}

.small-up-4 > .cell {
  width: 25%;
}

.small-up-5 > .cell {
  width: 20%;
}

.small-up-6 > .cell {
  width: 16.6666666667%;
}

.small-up-7 > .cell {
  width: 14.2857142857%;
}

.small-up-8 > .cell {
  width: 12.5%;
}

@media print, screen and (min-width: 40em) {
  .medium-up-1 > .cell {
    width: 100%;
  }
  .medium-up-2 > .cell {
    width: 50%;
  }
  .medium-up-3 > .cell {
    width: 33.3333333333%;
  }
  .medium-up-4 > .cell {
    width: 25%;
  }
  .medium-up-5 > .cell {
    width: 20%;
  }
  .medium-up-6 > .cell {
    width: 16.6666666667%;
  }
  .medium-up-7 > .cell {
    width: 14.2857142857%;
  }
  .medium-up-8 > .cell {
    width: 12.5%;
  }
}
@media print, screen and (min-width: 64em) {
  .large-up-1 > .cell {
    width: 100%;
  }
  .large-up-2 > .cell {
    width: 50%;
  }
  .large-up-3 > .cell {
    width: 33.3333333333%;
  }
  .large-up-4 > .cell {
    width: 25%;
  }
  .large-up-5 > .cell {
    width: 20%;
  }
  .large-up-6 > .cell {
    width: 16.6666666667%;
  }
  .large-up-7 > .cell {
    width: 14.2857142857%;
  }
  .large-up-8 > .cell {
    width: 12.5%;
  }
}
.grid-margin-x.small-up-1 > .cell {
  width: calc(100% - 1.25rem);
}

.grid-margin-x.small-up-2 > .cell {
  width: calc(50% - 1.25rem);
}

.grid-margin-x.small-up-3 > .cell {
  width: calc(33.3333333333% - 1.25rem);
}

.grid-margin-x.small-up-4 > .cell {
  width: calc(25% - 1.25rem);
}

.grid-margin-x.small-up-5 > .cell {
  width: calc(20% - 1.25rem);
}

.grid-margin-x.small-up-6 > .cell {
  width: calc(16.6666666667% - 1.25rem);
}

.grid-margin-x.small-up-7 > .cell {
  width: calc(14.2857142857% - 1.25rem);
}

.grid-margin-x.small-up-8 > .cell {
  width: calc(12.5% - 1.25rem);
}

@media print, screen and (min-width: 40em) {
  .grid-margin-x.small-up-1 > .cell {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x.small-up-2 > .cell {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x.small-up-3 > .cell {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x.small-up-4 > .cell {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x.small-up-5 > .cell {
    width: calc(20% - 1.875rem);
  }
  .grid-margin-x.small-up-6 > .cell {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x.small-up-7 > .cell {
    width: calc(14.2857142857% - 1.875rem);
  }
  .grid-margin-x.small-up-8 > .cell {
    width: calc(12.5% - 1.875rem);
  }
  .grid-margin-x.medium-up-1 > .cell {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x.medium-up-2 > .cell {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x.medium-up-3 > .cell {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x.medium-up-4 > .cell {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x.medium-up-5 > .cell {
    width: calc(20% - 1.875rem);
  }
  .grid-margin-x.medium-up-6 > .cell {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x.medium-up-7 > .cell {
    width: calc(14.2857142857% - 1.875rem);
  }
  .grid-margin-x.medium-up-8 > .cell {
    width: calc(12.5% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-x.large-up-1 > .cell {
    width: calc(100% - 1.875rem);
  }
  .grid-margin-x.large-up-2 > .cell {
    width: calc(50% - 1.875rem);
  }
  .grid-margin-x.large-up-3 > .cell {
    width: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-x.large-up-4 > .cell {
    width: calc(25% - 1.875rem);
  }
  .grid-margin-x.large-up-5 > .cell {
    width: calc(20% - 1.875rem);
  }
  .grid-margin-x.large-up-6 > .cell {
    width: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-x.large-up-7 > .cell {
    width: calc(14.2857142857% - 1.875rem);
  }
  .grid-margin-x.large-up-8 > .cell {
    width: calc(12.5% - 1.875rem);
  }
}
.small-margin-collapse {
  margin-right: 0;
  margin-left: 0;
}
.small-margin-collapse > .cell {
  margin-right: 0;
  margin-left: 0;
}
.small-margin-collapse > .small-1 {
  width: 8.3333333333%;
}
.small-margin-collapse > .small-2 {
  width: 16.6666666667%;
}
.small-margin-collapse > .small-3 {
  width: 25%;
}
.small-margin-collapse > .small-4 {
  width: 33.3333333333%;
}
.small-margin-collapse > .small-5 {
  width: 41.6666666667%;
}
.small-margin-collapse > .small-6 {
  width: 50%;
}
.small-margin-collapse > .small-7 {
  width: 58.3333333333%;
}
.small-margin-collapse > .small-8 {
  width: 66.6666666667%;
}
.small-margin-collapse > .small-9 {
  width: 75%;
}
.small-margin-collapse > .small-10 {
  width: 83.3333333333%;
}
.small-margin-collapse > .small-11 {
  width: 91.6666666667%;
}
.small-margin-collapse > .small-12 {
  width: 100%;
}
@media print, screen and (min-width: 40em) {
  .small-margin-collapse > .medium-1 {
    width: 8.3333333333%;
  }
  .small-margin-collapse > .medium-2 {
    width: 16.6666666667%;
  }
  .small-margin-collapse > .medium-3 {
    width: 25%;
  }
  .small-margin-collapse > .medium-4 {
    width: 33.3333333333%;
  }
  .small-margin-collapse > .medium-5 {
    width: 41.6666666667%;
  }
  .small-margin-collapse > .medium-6 {
    width: 50%;
  }
  .small-margin-collapse > .medium-7 {
    width: 58.3333333333%;
  }
  .small-margin-collapse > .medium-8 {
    width: 66.6666666667%;
  }
  .small-margin-collapse > .medium-9 {
    width: 75%;
  }
  .small-margin-collapse > .medium-10 {
    width: 83.3333333333%;
  }
  .small-margin-collapse > .medium-11 {
    width: 91.6666666667%;
  }
  .small-margin-collapse > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .small-margin-collapse > .large-1 {
    width: 8.3333333333%;
  }
  .small-margin-collapse > .large-2 {
    width: 16.6666666667%;
  }
  .small-margin-collapse > .large-3 {
    width: 25%;
  }
  .small-margin-collapse > .large-4 {
    width: 33.3333333333%;
  }
  .small-margin-collapse > .large-5 {
    width: 41.6666666667%;
  }
  .small-margin-collapse > .large-6 {
    width: 50%;
  }
  .small-margin-collapse > .large-7 {
    width: 58.3333333333%;
  }
  .small-margin-collapse > .large-8 {
    width: 66.6666666667%;
  }
  .small-margin-collapse > .large-9 {
    width: 75%;
  }
  .small-margin-collapse > .large-10 {
    width: 83.3333333333%;
  }
  .small-margin-collapse > .large-11 {
    width: 91.6666666667%;
  }
  .small-margin-collapse > .large-12 {
    width: 100%;
  }
}

.small-padding-collapse {
  margin-right: 0;
  margin-left: 0;
}
.small-padding-collapse > .cell {
  padding-right: 0;
  padding-left: 0;
}

@media print, screen and (min-width: 40em) {
  .medium-margin-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .medium-margin-collapse > .cell {
    margin-right: 0;
    margin-left: 0;
  }
}
@media print, screen and (min-width: 40em) {
  .medium-margin-collapse > .small-1 {
    width: 8.3333333333%;
  }
  .medium-margin-collapse > .small-2 {
    width: 16.6666666667%;
  }
  .medium-margin-collapse > .small-3 {
    width: 25%;
  }
  .medium-margin-collapse > .small-4 {
    width: 33.3333333333%;
  }
  .medium-margin-collapse > .small-5 {
    width: 41.6666666667%;
  }
  .medium-margin-collapse > .small-6 {
    width: 50%;
  }
  .medium-margin-collapse > .small-7 {
    width: 58.3333333333%;
  }
  .medium-margin-collapse > .small-8 {
    width: 66.6666666667%;
  }
  .medium-margin-collapse > .small-9 {
    width: 75%;
  }
  .medium-margin-collapse > .small-10 {
    width: 83.3333333333%;
  }
  .medium-margin-collapse > .small-11 {
    width: 91.6666666667%;
  }
  .medium-margin-collapse > .small-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 40em) {
  .medium-margin-collapse > .medium-1 {
    width: 8.3333333333%;
  }
  .medium-margin-collapse > .medium-2 {
    width: 16.6666666667%;
  }
  .medium-margin-collapse > .medium-3 {
    width: 25%;
  }
  .medium-margin-collapse > .medium-4 {
    width: 33.3333333333%;
  }
  .medium-margin-collapse > .medium-5 {
    width: 41.6666666667%;
  }
  .medium-margin-collapse > .medium-6 {
    width: 50%;
  }
  .medium-margin-collapse > .medium-7 {
    width: 58.3333333333%;
  }
  .medium-margin-collapse > .medium-8 {
    width: 66.6666666667%;
  }
  .medium-margin-collapse > .medium-9 {
    width: 75%;
  }
  .medium-margin-collapse > .medium-10 {
    width: 83.3333333333%;
  }
  .medium-margin-collapse > .medium-11 {
    width: 91.6666666667%;
  }
  .medium-margin-collapse > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .medium-margin-collapse > .large-1 {
    width: 8.3333333333%;
  }
  .medium-margin-collapse > .large-2 {
    width: 16.6666666667%;
  }
  .medium-margin-collapse > .large-3 {
    width: 25%;
  }
  .medium-margin-collapse > .large-4 {
    width: 33.3333333333%;
  }
  .medium-margin-collapse > .large-5 {
    width: 41.6666666667%;
  }
  .medium-margin-collapse > .large-6 {
    width: 50%;
  }
  .medium-margin-collapse > .large-7 {
    width: 58.3333333333%;
  }
  .medium-margin-collapse > .large-8 {
    width: 66.6666666667%;
  }
  .medium-margin-collapse > .large-9 {
    width: 75%;
  }
  .medium-margin-collapse > .large-10 {
    width: 83.3333333333%;
  }
  .medium-margin-collapse > .large-11 {
    width: 91.6666666667%;
  }
  .medium-margin-collapse > .large-12 {
    width: 100%;
  }
}

@media print, screen and (min-width: 40em) {
  .medium-padding-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .medium-padding-collapse > .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

@media print, screen and (min-width: 64em) {
  .large-margin-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .large-margin-collapse > .cell {
    margin-right: 0;
    margin-left: 0;
  }
}
@media print, screen and (min-width: 64em) {
  .large-margin-collapse > .small-1 {
    width: 8.3333333333%;
  }
  .large-margin-collapse > .small-2 {
    width: 16.6666666667%;
  }
  .large-margin-collapse > .small-3 {
    width: 25%;
  }
  .large-margin-collapse > .small-4 {
    width: 33.3333333333%;
  }
  .large-margin-collapse > .small-5 {
    width: 41.6666666667%;
  }
  .large-margin-collapse > .small-6 {
    width: 50%;
  }
  .large-margin-collapse > .small-7 {
    width: 58.3333333333%;
  }
  .large-margin-collapse > .small-8 {
    width: 66.6666666667%;
  }
  .large-margin-collapse > .small-9 {
    width: 75%;
  }
  .large-margin-collapse > .small-10 {
    width: 83.3333333333%;
  }
  .large-margin-collapse > .small-11 {
    width: 91.6666666667%;
  }
  .large-margin-collapse > .small-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .large-margin-collapse > .medium-1 {
    width: 8.3333333333%;
  }
  .large-margin-collapse > .medium-2 {
    width: 16.6666666667%;
  }
  .large-margin-collapse > .medium-3 {
    width: 25%;
  }
  .large-margin-collapse > .medium-4 {
    width: 33.3333333333%;
  }
  .large-margin-collapse > .medium-5 {
    width: 41.6666666667%;
  }
  .large-margin-collapse > .medium-6 {
    width: 50%;
  }
  .large-margin-collapse > .medium-7 {
    width: 58.3333333333%;
  }
  .large-margin-collapse > .medium-8 {
    width: 66.6666666667%;
  }
  .large-margin-collapse > .medium-9 {
    width: 75%;
  }
  .large-margin-collapse > .medium-10 {
    width: 83.3333333333%;
  }
  .large-margin-collapse > .medium-11 {
    width: 91.6666666667%;
  }
  .large-margin-collapse > .medium-12 {
    width: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .large-margin-collapse > .large-1 {
    width: 8.3333333333%;
  }
  .large-margin-collapse > .large-2 {
    width: 16.6666666667%;
  }
  .large-margin-collapse > .large-3 {
    width: 25%;
  }
  .large-margin-collapse > .large-4 {
    width: 33.3333333333%;
  }
  .large-margin-collapse > .large-5 {
    width: 41.6666666667%;
  }
  .large-margin-collapse > .large-6 {
    width: 50%;
  }
  .large-margin-collapse > .large-7 {
    width: 58.3333333333%;
  }
  .large-margin-collapse > .large-8 {
    width: 66.6666666667%;
  }
  .large-margin-collapse > .large-9 {
    width: 75%;
  }
  .large-margin-collapse > .large-10 {
    width: 83.3333333333%;
  }
  .large-margin-collapse > .large-11 {
    width: 91.6666666667%;
  }
  .large-margin-collapse > .large-12 {
    width: 100%;
  }
}

@media print, screen and (min-width: 64em) {
  .large-padding-collapse {
    margin-right: 0;
    margin-left: 0;
  }
  .large-padding-collapse > .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

.small-offset-0 {
  margin-left: 0%;
}

.grid-margin-x > .small-offset-0 {
  margin-left: calc(0% + 1.25rem / 2);
}

.small-offset-1 {
  margin-left: 8.3333333333%;
}

.grid-margin-x > .small-offset-1 {
  margin-left: calc(8.3333333333% + 1.25rem / 2);
}

.small-offset-2 {
  margin-left: 16.6666666667%;
}

.grid-margin-x > .small-offset-2 {
  margin-left: calc(16.6666666667% + 1.25rem / 2);
}

.small-offset-3 {
  margin-left: 25%;
}

.grid-margin-x > .small-offset-3 {
  margin-left: calc(25% + 1.25rem / 2);
}

.small-offset-4 {
  margin-left: 33.3333333333%;
}

.grid-margin-x > .small-offset-4 {
  margin-left: calc(33.3333333333% + 1.25rem / 2);
}

.small-offset-5 {
  margin-left: 41.6666666667%;
}

.grid-margin-x > .small-offset-5 {
  margin-left: calc(41.6666666667% + 1.25rem / 2);
}

.small-offset-6 {
  margin-left: 50%;
}

.grid-margin-x > .small-offset-6 {
  margin-left: calc(50% + 1.25rem / 2);
}

.small-offset-7 {
  margin-left: 58.3333333333%;
}

.grid-margin-x > .small-offset-7 {
  margin-left: calc(58.3333333333% + 1.25rem / 2);
}

.small-offset-8 {
  margin-left: 66.6666666667%;
}

.grid-margin-x > .small-offset-8 {
  margin-left: calc(66.6666666667% + 1.25rem / 2);
}

.small-offset-9 {
  margin-left: 75%;
}

.grid-margin-x > .small-offset-9 {
  margin-left: calc(75% + 1.25rem / 2);
}

.small-offset-10 {
  margin-left: 83.3333333333%;
}

.grid-margin-x > .small-offset-10 {
  margin-left: calc(83.3333333333% + 1.25rem / 2);
}

.small-offset-11 {
  margin-left: 91.6666666667%;
}

.grid-margin-x > .small-offset-11 {
  margin-left: calc(91.6666666667% + 1.25rem / 2);
}

@media print, screen and (min-width: 40em) {
  .medium-offset-0 {
    margin-left: 0%;
  }
  .grid-margin-x > .medium-offset-0 {
    margin-left: calc(0% + 1.875rem / 2);
  }
  .medium-offset-1 {
    margin-left: 8.3333333333%;
  }
  .grid-margin-x > .medium-offset-1 {
    margin-left: calc(8.3333333333% + 1.875rem / 2);
  }
  .medium-offset-2 {
    margin-left: 16.6666666667%;
  }
  .grid-margin-x > .medium-offset-2 {
    margin-left: calc(16.6666666667% + 1.875rem / 2);
  }
  .medium-offset-3 {
    margin-left: 25%;
  }
  .grid-margin-x > .medium-offset-3 {
    margin-left: calc(25% + 1.875rem / 2);
  }
  .medium-offset-4 {
    margin-left: 33.3333333333%;
  }
  .grid-margin-x > .medium-offset-4 {
    margin-left: calc(33.3333333333% + 1.875rem / 2);
  }
  .medium-offset-5 {
    margin-left: 41.6666666667%;
  }
  .grid-margin-x > .medium-offset-5 {
    margin-left: calc(41.6666666667% + 1.875rem / 2);
  }
  .medium-offset-6 {
    margin-left: 50%;
  }
  .grid-margin-x > .medium-offset-6 {
    margin-left: calc(50% + 1.875rem / 2);
  }
  .medium-offset-7 {
    margin-left: 58.3333333333%;
  }
  .grid-margin-x > .medium-offset-7 {
    margin-left: calc(58.3333333333% + 1.875rem / 2);
  }
  .medium-offset-8 {
    margin-left: 66.6666666667%;
  }
  .grid-margin-x > .medium-offset-8 {
    margin-left: calc(66.6666666667% + 1.875rem / 2);
  }
  .medium-offset-9 {
    margin-left: 75%;
  }
  .grid-margin-x > .medium-offset-9 {
    margin-left: calc(75% + 1.875rem / 2);
  }
  .medium-offset-10 {
    margin-left: 83.3333333333%;
  }
  .grid-margin-x > .medium-offset-10 {
    margin-left: calc(83.3333333333% + 1.875rem / 2);
  }
  .medium-offset-11 {
    margin-left: 91.6666666667%;
  }
  .grid-margin-x > .medium-offset-11 {
    margin-left: calc(91.6666666667% + 1.875rem / 2);
  }
}
@media print, screen and (min-width: 64em) {
  .large-offset-0 {
    margin-left: 0%;
  }
  .grid-margin-x > .large-offset-0 {
    margin-left: calc(0% + 1.875rem / 2);
  }
  .large-offset-1 {
    margin-left: 8.3333333333%;
  }
  .grid-margin-x > .large-offset-1 {
    margin-left: calc(8.3333333333% + 1.875rem / 2);
  }
  .large-offset-2 {
    margin-left: 16.6666666667%;
  }
  .grid-margin-x > .large-offset-2 {
    margin-left: calc(16.6666666667% + 1.875rem / 2);
  }
  .large-offset-3 {
    margin-left: 25%;
  }
  .grid-margin-x > .large-offset-3 {
    margin-left: calc(25% + 1.875rem / 2);
  }
  .large-offset-4 {
    margin-left: 33.3333333333%;
  }
  .grid-margin-x > .large-offset-4 {
    margin-left: calc(33.3333333333% + 1.875rem / 2);
  }
  .large-offset-5 {
    margin-left: 41.6666666667%;
  }
  .grid-margin-x > .large-offset-5 {
    margin-left: calc(41.6666666667% + 1.875rem / 2);
  }
  .large-offset-6 {
    margin-left: 50%;
  }
  .grid-margin-x > .large-offset-6 {
    margin-left: calc(50% + 1.875rem / 2);
  }
  .large-offset-7 {
    margin-left: 58.3333333333%;
  }
  .grid-margin-x > .large-offset-7 {
    margin-left: calc(58.3333333333% + 1.875rem / 2);
  }
  .large-offset-8 {
    margin-left: 66.6666666667%;
  }
  .grid-margin-x > .large-offset-8 {
    margin-left: calc(66.6666666667% + 1.875rem / 2);
  }
  .large-offset-9 {
    margin-left: 75%;
  }
  .grid-margin-x > .large-offset-9 {
    margin-left: calc(75% + 1.875rem / 2);
  }
  .large-offset-10 {
    margin-left: 83.3333333333%;
  }
  .grid-margin-x > .large-offset-10 {
    margin-left: calc(83.3333333333% + 1.875rem / 2);
  }
  .large-offset-11 {
    margin-left: 91.6666666667%;
  }
  .grid-margin-x > .large-offset-11 {
    margin-left: calc(91.6666666667% + 1.875rem / 2);
  }
}
.grid-y {
  display: flex;
  flex-flow: column nowrap;
}
.grid-y > .cell {
  height: auto;
  max-height: none;
}
.grid-y > .auto {
  height: auto;
}
.grid-y > .shrink {
  height: auto;
}
.grid-y > .small-shrink, .grid-y > .small-full, .grid-y > .small-1, .grid-y > .small-2, .grid-y > .small-3, .grid-y > .small-4, .grid-y > .small-5, .grid-y > .small-6, .grid-y > .small-7, .grid-y > .small-8, .grid-y > .small-9, .grid-y > .small-10, .grid-y > .small-11, .grid-y > .small-12 {
  flex-basis: auto;
}
@media print, screen and (min-width: 40em) {
  .grid-y > .medium-shrink, .grid-y > .medium-full, .grid-y > .medium-1, .grid-y > .medium-2, .grid-y > .medium-3, .grid-y > .medium-4, .grid-y > .medium-5, .grid-y > .medium-6, .grid-y > .medium-7, .grid-y > .medium-8, .grid-y > .medium-9, .grid-y > .medium-10, .grid-y > .medium-11, .grid-y > .medium-12 {
    flex-basis: auto;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-y > .large-shrink, .grid-y > .large-full, .grid-y > .large-1, .grid-y > .large-2, .grid-y > .large-3, .grid-y > .large-4, .grid-y > .large-5, .grid-y > .large-6, .grid-y > .large-7, .grid-y > .large-8, .grid-y > .large-9, .grid-y > .large-10, .grid-y > .large-11, .grid-y > .large-12 {
    flex-basis: auto;
  }
}
.grid-y > .small-12, .grid-y > .small-11, .grid-y > .small-10, .grid-y > .small-9, .grid-y > .small-8, .grid-y > .small-7, .grid-y > .small-6, .grid-y > .small-5, .grid-y > .small-4, .grid-y > .small-3, .grid-y > .small-2, .grid-y > .small-1 {
  flex: 0 0 auto;
}
.grid-y > .small-1 {
  height: 8.3333333333%;
}
.grid-y > .small-2 {
  height: 16.6666666667%;
}
.grid-y > .small-3 {
  height: 25%;
}
.grid-y > .small-4 {
  height: 33.3333333333%;
}
.grid-y > .small-5 {
  height: 41.6666666667%;
}
.grid-y > .small-6 {
  height: 50%;
}
.grid-y > .small-7 {
  height: 58.3333333333%;
}
.grid-y > .small-8 {
  height: 66.6666666667%;
}
.grid-y > .small-9 {
  height: 75%;
}
.grid-y > .small-10 {
  height: 83.3333333333%;
}
.grid-y > .small-11 {
  height: 91.6666666667%;
}
.grid-y > .small-12 {
  height: 100%;
}
@media print, screen and (min-width: 40em) {
  .grid-y > .medium-auto {
    flex: 1 1 0;
    height: auto;
  }
  .grid-y > .medium-12, .grid-y > .medium-11, .grid-y > .medium-10, .grid-y > .medium-9, .grid-y > .medium-8, .grid-y > .medium-7, .grid-y > .medium-6, .grid-y > .medium-5, .grid-y > .medium-4, .grid-y > .medium-3, .grid-y > .medium-2, .grid-y > .medium-1, .grid-y > .medium-shrink {
    flex: 0 0 auto;
  }
  .grid-y > .medium-shrink {
    height: auto;
  }
  .grid-y > .medium-1 {
    height: 8.3333333333%;
  }
  .grid-y > .medium-2 {
    height: 16.6666666667%;
  }
  .grid-y > .medium-3 {
    height: 25%;
  }
  .grid-y > .medium-4 {
    height: 33.3333333333%;
  }
  .grid-y > .medium-5 {
    height: 41.6666666667%;
  }
  .grid-y > .medium-6 {
    height: 50%;
  }
  .grid-y > .medium-7 {
    height: 58.3333333333%;
  }
  .grid-y > .medium-8 {
    height: 66.6666666667%;
  }
  .grid-y > .medium-9 {
    height: 75%;
  }
  .grid-y > .medium-10 {
    height: 83.3333333333%;
  }
  .grid-y > .medium-11 {
    height: 91.6666666667%;
  }
  .grid-y > .medium-12 {
    height: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-y > .large-auto {
    flex: 1 1 0;
    height: auto;
  }
  .grid-y > .large-12, .grid-y > .large-11, .grid-y > .large-10, .grid-y > .large-9, .grid-y > .large-8, .grid-y > .large-7, .grid-y > .large-6, .grid-y > .large-5, .grid-y > .large-4, .grid-y > .large-3, .grid-y > .large-2, .grid-y > .large-1, .grid-y > .large-shrink {
    flex: 0 0 auto;
  }
  .grid-y > .large-shrink {
    height: auto;
  }
  .grid-y > .large-1 {
    height: 8.3333333333%;
  }
  .grid-y > .large-2 {
    height: 16.6666666667%;
  }
  .grid-y > .large-3 {
    height: 25%;
  }
  .grid-y > .large-4 {
    height: 33.3333333333%;
  }
  .grid-y > .large-5 {
    height: 41.6666666667%;
  }
  .grid-y > .large-6 {
    height: 50%;
  }
  .grid-y > .large-7 {
    height: 58.3333333333%;
  }
  .grid-y > .large-8 {
    height: 66.6666666667%;
  }
  .grid-y > .large-9 {
    height: 75%;
  }
  .grid-y > .large-10 {
    height: 83.3333333333%;
  }
  .grid-y > .large-11 {
    height: 91.6666666667%;
  }
  .grid-y > .large-12 {
    height: 100%;
  }
}

.grid-padding-y .grid-padding-y {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-y .grid-padding-y {
    margin-top: -0.9375rem;
    margin-bottom: -0.9375rem;
  }
}
.grid-padding-y > .cell {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-padding-y > .cell {
    padding-top: 0.9375rem;
    padding-bottom: 0.9375rem;
  }
}

.grid-margin-y {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y {
    margin-top: -0.9375rem;
    margin-bottom: -0.9375rem;
  }
}
.grid-margin-y > .cell {
  height: calc(100% - 1.25rem);
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .cell {
    height: calc(100% - 1.875rem);
    margin-top: 0.9375rem;
    margin-bottom: 0.9375rem;
  }
}
.grid-margin-y > .auto {
  height: auto;
}
.grid-margin-y > .shrink {
  height: auto;
}
.grid-margin-y > .small-1 {
  height: calc(8.3333333333% - 1.25rem);
}
.grid-margin-y > .small-2 {
  height: calc(16.6666666667% - 1.25rem);
}
.grid-margin-y > .small-3 {
  height: calc(25% - 1.25rem);
}
.grid-margin-y > .small-4 {
  height: calc(33.3333333333% - 1.25rem);
}
.grid-margin-y > .small-5 {
  height: calc(41.6666666667% - 1.25rem);
}
.grid-margin-y > .small-6 {
  height: calc(50% - 1.25rem);
}
.grid-margin-y > .small-7 {
  height: calc(58.3333333333% - 1.25rem);
}
.grid-margin-y > .small-8 {
  height: calc(66.6666666667% - 1.25rem);
}
.grid-margin-y > .small-9 {
  height: calc(75% - 1.25rem);
}
.grid-margin-y > .small-10 {
  height: calc(83.3333333333% - 1.25rem);
}
.grid-margin-y > .small-11 {
  height: calc(91.6666666667% - 1.25rem);
}
.grid-margin-y > .small-12 {
  height: calc(100% - 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .auto {
    height: auto;
  }
  .grid-margin-y > .shrink {
    height: auto;
  }
  .grid-margin-y > .small-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .small-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .small-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .small-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-12 {
    height: calc(100% - 1.875rem);
  }
  .grid-margin-y > .medium-auto {
    height: auto;
  }
  .grid-margin-y > .medium-shrink {
    height: auto;
  }
  .grid-margin-y > .medium-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .medium-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .medium-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .medium-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-12 {
    height: calc(100% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-y > .large-auto {
    height: auto;
  }
  .grid-margin-y > .large-shrink {
    height: auto;
  }
  .grid-margin-y > .large-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .large-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .large-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .large-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-12 {
    height: calc(100% - 1.875rem);
  }
}

.grid-frame {
  overflow: hidden;
  position: relative;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100vw;
}

.cell .grid-frame {
  width: 100%;
}

.cell-block {
  overflow-x: auto;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.cell-block-y {
  overflow-y: auto;
  max-height: 100%;
  min-height: 100%;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.cell-block-container {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.cell-block-container > .grid-x {
  max-height: 100%;
  flex-wrap: nowrap;
}

@media print, screen and (min-width: 40em) {
  .medium-grid-frame {
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    width: 100vw;
  }
  .cell .medium-grid-frame {
    width: 100%;
  }
  .medium-cell-block {
    overflow-x: auto;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .medium-cell-block-container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
  .medium-cell-block-container > .grid-x {
    max-height: 100%;
    flex-wrap: nowrap;
  }
  .medium-cell-block-y {
    overflow-y: auto;
    max-height: 100%;
    min-height: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
}
@media print, screen and (min-width: 64em) {
  .large-grid-frame {
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    width: 100vw;
  }
  .cell .large-grid-frame {
    width: 100%;
  }
  .large-cell-block {
    overflow-x: auto;
    max-width: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .large-cell-block-container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
  .large-cell-block-container > .grid-x {
    max-height: 100%;
    flex-wrap: nowrap;
  }
  .large-cell-block-y {
    overflow-y: auto;
    max-height: 100%;
    min-height: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
}
.grid-y.grid-frame {
  overflow: hidden;
  position: relative;
  flex-wrap: nowrap;
  align-items: stretch;
  height: 100vh;
  width: auto;
}
@media print, screen and (min-width: 40em) {
  .grid-y.medium-grid-frame {
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    height: 100vh;
    width: auto;
  }
}
@media print, screen and (min-width: 64em) {
  .grid-y.large-grid-frame {
    overflow: hidden;
    position: relative;
    flex-wrap: nowrap;
    align-items: stretch;
    height: 100vh;
    width: auto;
  }
}

.cell .grid-y.grid-frame {
  height: 100%;
}
@media print, screen and (min-width: 40em) {
  .cell .grid-y.medium-grid-frame {
    height: 100%;
  }
}
@media print, screen and (min-width: 64em) {
  .cell .grid-y.large-grid-frame {
    height: 100%;
  }
}

.grid-margin-y {
  margin-top: -0.625rem;
  margin-bottom: -0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y {
    margin-top: -0.9375rem;
    margin-bottom: -0.9375rem;
  }
}
.grid-margin-y > .cell {
  height: calc(100% - 1.25rem);
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .cell {
    height: calc(100% - 1.875rem);
    margin-top: 0.9375rem;
    margin-bottom: 0.9375rem;
  }
}
.grid-margin-y > .auto {
  height: auto;
}
.grid-margin-y > .shrink {
  height: auto;
}
.grid-margin-y > .small-1 {
  height: calc(8.3333333333% - 1.25rem);
}
.grid-margin-y > .small-2 {
  height: calc(16.6666666667% - 1.25rem);
}
.grid-margin-y > .small-3 {
  height: calc(25% - 1.25rem);
}
.grid-margin-y > .small-4 {
  height: calc(33.3333333333% - 1.25rem);
}
.grid-margin-y > .small-5 {
  height: calc(41.6666666667% - 1.25rem);
}
.grid-margin-y > .small-6 {
  height: calc(50% - 1.25rem);
}
.grid-margin-y > .small-7 {
  height: calc(58.3333333333% - 1.25rem);
}
.grid-margin-y > .small-8 {
  height: calc(66.6666666667% - 1.25rem);
}
.grid-margin-y > .small-9 {
  height: calc(75% - 1.25rem);
}
.grid-margin-y > .small-10 {
  height: calc(83.3333333333% - 1.25rem);
}
.grid-margin-y > .small-11 {
  height: calc(91.6666666667% - 1.25rem);
}
.grid-margin-y > .small-12 {
  height: calc(100% - 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-margin-y > .auto {
    height: auto;
  }
  .grid-margin-y > .shrink {
    height: auto;
  }
  .grid-margin-y > .small-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .small-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .small-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .small-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .small-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .small-12 {
    height: calc(100% - 1.875rem);
  }
  .grid-margin-y > .medium-auto {
    height: auto;
  }
  .grid-margin-y > .medium-shrink {
    height: auto;
  }
  .grid-margin-y > .medium-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .medium-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .medium-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .medium-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .medium-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .medium-12 {
    height: calc(100% - 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-y > .large-auto {
    height: auto;
  }
  .grid-margin-y > .large-shrink {
    height: auto;
  }
  .grid-margin-y > .large-1 {
    height: calc(8.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-2 {
    height: calc(16.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-3 {
    height: calc(25% - 1.875rem);
  }
  .grid-margin-y > .large-4 {
    height: calc(33.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-5 {
    height: calc(41.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-6 {
    height: calc(50% - 1.875rem);
  }
  .grid-margin-y > .large-7 {
    height: calc(58.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-8 {
    height: calc(66.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-9 {
    height: calc(75% - 1.875rem);
  }
  .grid-margin-y > .large-10 {
    height: calc(83.3333333333% - 1.875rem);
  }
  .grid-margin-y > .large-11 {
    height: calc(91.6666666667% - 1.875rem);
  }
  .grid-margin-y > .large-12 {
    height: calc(100% - 1.875rem);
  }
}

.grid-frame.grid-margin-y {
  height: calc(100vh + 1.25rem);
}
@media print, screen and (min-width: 40em) {
  .grid-frame.grid-margin-y {
    height: calc(100vh + 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-frame.grid-margin-y {
    height: calc(100vh + 1.875rem);
  }
}

@media print, screen and (min-width: 40em) {
  .grid-margin-y.medium-grid-frame {
    height: calc(100vh + 1.875rem);
  }
}
@media print, screen and (min-width: 64em) {
  .grid-margin-y.large-grid-frame {
    height: calc(100vh + 1.875rem);
  }
}
.masonry-grid {
  width: 100%;
}
.masonry-grid .masonry-grid-item,
.masonry-grid .grid-sizer {
  width: 48.75%;
  break-inside: avoid;
  margin-bottom: 1rem;
  line-height: 0;
  float: left;
}
@media print, screen and (min-width: 40em) {
  .masonry-grid .masonry-grid-item,
  .masonry-grid .grid-sizer {
    width: 32.3333333%;
  }
}
@media print, screen and (min-width: 64em) {
  .masonry-grid .masonry-grid-item,
  .masonry-grid .grid-sizer {
    width: 23.882681575;
  }
}
@media screen and (min-width: 75em) {
  .masonry-grid .masonry-grid-item,
  .masonry-grid .grid-sizer {
    width: 18.80819368%;
  }
}
.masonry-grid .masonry-grid-item img,
.masonry-grid .masonry-grid-item video,
.masonry-grid .grid-sizer img,
.masonry-grid .grid-sizer video {
  display: block;
  position: absolute;
  top: 0;
  max-width: 100%;
}
.masonry-grid .masonry-grid-item a,
.masonry-grid .grid-sizer a {
  width: 100%;
  display: block;
  cursor: pointer;
}
.masonry-grid .gutter-sizer {
  width: 2.5%;
}
@media print, screen and (min-width: 40em) {
  .masonry-grid .gutter-sizer {
    width: 1.5%;
  }
}
@media print, screen and (min-width: 64em) {
  .masonry-grid .gutter-sizer {
    width: 1.4897579%;
  }
}

.photoset-preview {
  padding: 10px;
  margin-bottom: 10px;
  background-color: #eee;
}

button.pswp__button--share-button {
  font-size: 18px;
  color: #fff;
}

#uicore-page #event-container, #uicore-page .single-image-view-container, #uicore-page .raffle-content {
  padding-top: 50px;
  padding-left: 10px;
  padding-right: 10px;
}
@media print, screen and (min-width: 40em) {
  #uicore-page #event-container, #uicore-page .single-image-view-container, #uicore-page .raffle-content {
    padding-top: 100px;
  }
}

#uicore-page .single-image-view-box {
  padding: 20px;
  background-color: var(--e-global-color-uicore_light);
}
#uicore-page .single-image-view-box img {
  display: block;
  width: 100%;
}
#uicore-page .single-image-view-box .buttons {
  padding-top: 20px;
  display: flex;
}
#uicore-page .single-image-view-box .buttons div {
  flex-grow: 1;
  text-align: center;
  flex-basis: 0;
}
#uicore-page .single-image-view-box .buttons i {
  font-size: 25px;
}

.dayswellwasted {
  padding: 50px;
  background-color: #000;
}

#uicore-page .raffle input {
  margin: 10px;
}`, "",{"version":3,"sources":["webpack://./node_modules/foundation-sites/scss/foundation.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_classes.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_grid.scss","webpack://./node_modules/foundation-sites/scss/_global.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_gutters.scss","webpack://./sass/style.scss","webpack://./node_modules/foundation-sites/scss/util/_breakpoint.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_cell.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_layout.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_collapse.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_position.scss","webpack://./node_modules/foundation-sites/scss/xy-grid/_frame.scss"],"names":[],"mappings":"AAAA;;;;;EAAA;ACYE;ECIA,gBCEa;EDDb,iBAAA;EACA,kBAAA;EEcM,uBAAA;EAAA,sBAAA;ACnBR;ACsKQ;ELvKN;IGoBM,wBAAA;IAAA,uBAAA;ECdN;AACF;AJJI;ECCF,eAAA;EACA,iBAAA;EACA,kBAAA;EEcM,uBAAA;EAAA,sBAAA;ACNR;ACyJQ;ELpKJ;IGiBI,wBAAA;IAAA,uBAAA;ECDN;AACF;AJbI;ECHF,eDI+B;ECH/B,iBAAA;EACA,kBAAA;EEuBI,gBAAA;EAAA,eAAA;ACFN;;AJdE;ECSA,aAAA;EACA,mBAAA;AGSF;;AJfE;EMuGA,cAAA;EAIE,aAAA;EACA,YAAA;EAsCA,WATM;AFnHV;AJnBI;EMoGF,WAAA;AF9EF;AJlBI;EMgGF,cAAA;AF3EF;;AJfI;EMqIA,WATM;AFzGV;AJfI;EMiIA,WATM;AFtGV;;AJFM;EACE,gBAAA;AIKR;;AC+GQ;ELrHF;IACE,gBAAA;EIUN;AACF;ACyGQ;ELrHF;IACE,gBAAA;EIeN;AACF;AJHI;EMwDF,cAAA;AFlDF;;AJSM;EMoFF,oBATM;AFhFV;;AJKM;EMoFF,qBATM;AF5EV;;AJCM;EMoFF,UATM;AFxEV;;AJHM;EMoFF,qBATM;AFpEV;;AJPM;EMoFF,qBATM;AFhEV;;AJXM;EMoFF,UATM;AF5DV;;AJfM;EMoFF,qBATM;AFxDV;;AJnBM;EMoFF,qBATM;AFpDV;;AJvBM;EMoFF,UATM;AFhDV;;AJ3BM;EMoFF,qBATM;AF5CV;;AJ/BM;EMoFF,qBATM;AFxCV;;AJnCM;EMoFF,WATM;AFpCV;;ACiDQ;EL5GF;IM6DJ,WAAA;IA2CE,WATM;EF9BR;EJ5DE;IMwDF,cAAA;EFOA;EJzDI;IM6FF,WATM;EFxBR;EJnDI;IMoFF,oBATM;EFrBR;EJtDI;IMoFF,qBATM;EFlBR;EJzDI;IMoFF,UATM;EFfR;EJ5DI;IMoFF,qBATM;EFZR;EJ/DI;IMoFF,qBATM;EFTR;EJlEI;IMoFF,UATM;EFNR;EJrEI;IMoFF,qBATM;EFHR;EJxEI;IMoFF,qBATM;EFAR;EJ3EI;IMoFF,UATM;EFGR;EJ9EI;IMoFF,qBATM;EFMR;EJjFI;IMoFF,qBATM;EFSR;EJpFI;IMoFF,WATM;EFYR;AACF;ACAQ;EL5GF;IM6DJ,WAAA;IA2CE,WATM;EFkBR;EJ5GE;IMwDF,cAAA;EFuDA;EJzGI;IM6FF,WATM;EFwBR;EJnGI;IMoFF,oBATM;EF2BR;EJtGI;IMoFF,qBATM;EF8BR;EJzGI;IMoFF,UATM;EFiCR;EJ5GI;IMoFF,qBATM;EFoCR;EJ/GI;IMoFF,qBATM;EFuCR;EJlHI;IMoFF,UATM;EF0CR;EJrHI;IMoFF,qBATM;EF6CR;EJxHI;IMoFF,qBATM;EFgDR;EJ3HI;IMoFF,UATM;EFmDR;EJ9HI;IMoFF,qBATM;EFsDR;EJjII;IMoFF,qBATM;EFyDR;EJpII;IMoFF,WATM;EF4DR;AACF;AJhIE;EACE,WAAA;AIkIJ;;AJ9HE;EACE,YAAA;AIiIJ;;AJnGE;EGvGM,sBAAA;EAAA,uBAAA;AC+MR;AC5DQ;EL5CN;IGvGM,uBAAA;IAAA,wBAAA;ECoNN;AACF;AJ1GI;EMoCA,2BATM;EH7HJ,qBAAA;EAAA,sBAAA;ACiNN;ACvEQ;ELjCA;IM6BJ,4BATM;IH7HJ,sBAAA;IAAA,uBAAA;ECuNJ;AACF;AJlJE;EMgEE,WATM;AF8FV;AJjJE;EM4DE,WATM;AFiGV;AJ5II;EMoDA,oCATM;AFoGV;AJ/II;EMoDA,qCATM;AFuGV;AJlJI;EMoDA,0BATM;AF0GV;AJrJI;EMoDA,qCATM;AF6GV;AJxJI;EMoDA,qCATM;AFgHV;AJ3JI;EMoDA,0BATM;AFmHV;AJ9JI;EMoDA,qCATM;AFsHV;AJjKI;EMoDA,qCATM;AFyHV;AJpKI;EMoDA,0BATM;AF4HV;AJvKI;EMoDA,qCATM;AF+HV;AJ1KI;EMoDA,qCATM;AFkIV;AJ7KI;EMoDA,2BATM;AFqIV;ACxHQ;ELpEN;IMgEE,WATM;EFyIR;EJ5LA;IM4DE,WATM;EF4IR;EJvLE;IMoDA,qCATM;EF+IR;EJ1LE;IMoDA,sCATM;EFkJR;EJ7LE;IMoDA,2BATM;EFqJR;EJhME;IMoDA,sCATM;EFwJR;EJnME;IMoDA,sCATM;EF2JR;EJtME;IMoDA,2BATM;EF8JR;EJzME;IMoDA,sCATM;EFiKR;EJ5ME;IMoDA,sCATM;EFoKR;EJ/ME;IMoDA,2BATM;EFuKR;EJlNE;IMoDA,sCATM;EF0KR;EJrNE;IMoDA,sCATM;EF6KR;EJxNE;IMoDA,4BATM;EFgLR;EJvOA;IMgEE,WATM;EFmLR;EJtOA;IM4DE,WATM;EFsLR;EJjOE;IMoDA,qCATM;EFyLR;EJpOE;IMoDA,sCATM;EF4LR;EJvOE;IMoDA,2BATM;EF+LR;EJ1OE;IMoDA,sCATM;EFkMR;EJ7OE;IMoDA,sCATM;EFqMR;EJhPE;IMoDA,2BATM;EFwMR;EJnPE;IMoDA,sCATM;EF2MR;EJtPE;IMoDA,sCATM;EF8MR;EJzPE;IMoDA,2BATM;EFiNR;EJ5PE;IMoDA,sCATM;EFoNR;EJ/PE;IMoDA,sCATM;EFuNR;EJlQE;IMoDA,4BATM;EF0NR;AACF;AC9MQ;ELpEN;IMgEE,WATM;EF+NR;EJlRA;IM4DE,WATM;EFkOR;EJ7QE;IMoDA,qCATM;EFqOR;EJhRE;IMoDA,sCATM;EFwOR;EJnRE;IMoDA,2BATM;EF2OR;EJtRE;IMoDA,sCATM;EF8OR;EJzRE;IMoDA,sCATM;EFiPR;EJ5RE;IMoDA,2BATM;EFoPR;EJ/RE;IMoDA,sCATM;EFuPR;EJlSE;IMoDA,sCATM;EF0PR;EJrSE;IMoDA,2BATM;EF6PR;EJxSE;IMoDA,sCATM;EFgQR;EJ3SE;IMoDA,sCATM;EFmQR;EJ9SE;IMoDA,4BATM;EFsQR;AACF;;AJ/PI;EG9II,uBAAA;EAAA,sBAAA;ACkZR;AC/PQ;ELLJ;IG9II,wBAAA;IAAA,uBAAA;ECuZN;AACF;AJpQI;EGpJI,uBAAA;EAAA,sBAAA;AC4ZR;ACzQQ;ELCJ;IGpJI,wBAAA;IAAA,uBAAA;ECiaN;AACF;AJzQI;EGzJI,uBAAA;EAAA,sBAAA;ACsaR;ACnRQ;ELMJ;IGzJI,wBAAA;IAAA,uBAAA;EC2aN;AACF;;AG5aE;ED+IE,WATM;AF0SV;;AGhbE;ED+IE,UATM;AF8SV;;AGpbE;ED+IE,qBATM;AFkTV;;AGxbE;ED+IE,UATM;AFsTV;;AG5bE;ED+IE,UATM;AF0TV;;AGhcE;ED+IE,qBATM;AF8TV;;AGpcE;ED+IE,qBATM;AFkUV;;AGxcE;ED+IE,YATM;AFsUV;;ACzTQ;EEnJN;ID+IE,WATM;EF2UR;EGjdA;ID+IE,UATM;EF8UR;EGpdA;ID+IE,qBATM;EFiVR;EGvdA;ID+IE,UATM;EFoVR;EG1dA;ID+IE,UATM;EFuVR;EG7dA;ID+IE,qBATM;EF0VR;EGheA;ID+IE,qBATM;EF6VR;EGneA;ID+IE,YATM;EFgWR;AACF;ACpVQ;EEnJN;ID+IE,WATM;EFqWR;EG3eA;ID+IE,UATM;EFwWR;EG9eA;ID+IE,qBATM;EF2WR;EGjfA;ID+IE,UATM;EF8WR;EGpfA;ID+IE,UATM;EFiXR;EGvfA;ID+IE,qBATM;EFoXR;EG1fA;ID+IE,qBATM;EFuXR;EG7fA;ID+IE,YATM;EF0XR;AACF;AGjgBE;ED+IE,2BATM;AF8XV;;AGpgBE;ED+IE,0BATM;AFkYV;;AGxgBE;ED+IE,qCATM;AFsYV;;AG5gBE;ED+IE,0BATM;AF0YV;;AGhhBE;ED+IE,0BATM;AF8YV;;AGphBE;ED+IE,qCATM;AFkZV;;AGxhBE;ED+IE,qCATM;AFsZV;;AG5hBE;ED+IE,4BATM;AF0ZV;;AC7YQ;EEnJN;ID+IE,4BATM;EF+ZR;EGriBA;ID+IE,2BATM;EFkaR;EGxiBA;ID+IE,sCATM;EFqaR;EG3iBA;ID+IE,2BATM;EFwaR;EG9iBA;ID+IE,2BATM;EF2aR;EGjjBA;ID+IE,sCATM;EF8aR;EGpjBA;ID+IE,sCATM;EFibR;EGvjBA;ID+IE,6BATM;EFobR;EG1jBA;ID+IE,4BATM;EFubR;EG7jBA;ID+IE,2BATM;EF0bR;EGhkBA;ID+IE,sCATM;EF6bR;EGnkBA;ID+IE,2BATM;EFgcR;EGtkBA;ID+IE,2BATM;EFmcR;EGzkBA;ID+IE,sCATM;EFscR;EG5kBA;ID+IE,sCATM;EFycR;EG/kBA;ID+IE,6BATM;EF4cR;AACF;AChcQ;EEnJN;ID+IE,4BATM;EFidR;EGvlBA;ID+IE,2BATM;EFodR;EG1lBA;ID+IE,sCATM;EFudR;EG7lBA;ID+IE,2BATM;EF0dR;EGhmBA;ID+IE,2BATM;EF6dR;EGnmBA;ID+IE,sCATM;EFgeR;EGtmBA;ID+IE,sCATM;EFmeR;EGzmBA;ID+IE,6BATM;EFseR;AACF;AJtaM;EQ9ME,eAAA;EAAA,cAAA;AJwnBR;AIrnBM;EAEI,eAAA;EAAA,cAAA;AJunBV;AIjmBY;EF2HR,oBATM;AFkfV;AIpmBY;EF2HR,qBATM;AFqfV;AIvmBY;EF2HR,UATM;AFwfV;AI1mBY;EF2HR,qBATM;AF2fV;AI7mBY;EF2HR,qBATM;AF8fV;AIhnBY;EF2HR,UATM;AFigBV;AInnBY;EF2HR,qBATM;AFogBV;AItnBY;EF2HR,qBATM;AFugBV;AIznBY;EF2HR,UATM;AF0gBV;AI5nBY;EF2HR,qBATM;AF6gBV;AI/nBY;EF2HR,qBATM;AFghBV;AIloBY;EF2HR,WATM;AFmhBV;ACtgBQ;EG/HI;IF2HR,oBATM;EFuhBR;EIzoBU;IF2HR,qBATM;EF0hBR;EI5oBU;IF2HR,UATM;EF6hBR;EI/oBU;IF2HR,qBATM;EFgiBR;EIlpBU;IF2HR,qBATM;EFmiBR;EIrpBU;IF2HR,UATM;EFsiBR;EIxpBU;IF2HR,qBATM;EFyiBR;EI3pBU;IF2HR,qBATM;EF4iBR;EI9pBU;IF2HR,UATM;EF+iBR;EIjqBU;IF2HR,qBATM;EFkjBR;EIpqBU;IF2HR,qBATM;EFqjBR;EIvqBU;IF2HR,WATM;EFwjBR;AACF;AC5iBQ;EG/HI;IF2HR,oBATM;EF6jBR;EI/qBU;IF2HR,qBATM;EFgkBR;EIlrBU;IF2HR,UATM;EFmkBR;EIrrBU;IF2HR,qBATM;EFskBR;EIxrBU;IF2HR,qBATM;EFykBR;EI3rBU;IF2HR,UATM;EF4kBR;EI9rBU;IF2HR,qBATM;EF+kBR;EIjsBU;IF2HR,qBATM;EFklBR;EIpsBU;IF2HR,UATM;EFqlBR;EIvsBU;IF2HR,qBATM;EFwlBR;EI1sBU;IF2HR,qBATM;EF2lBR;EI7sBU;IF2HR,WATM;EF8lBR;AACF;;AJxhBM;EQ7KE,eAAA;EAAA,cAAA;AJ0sBR;AIvsBM;EAEI,gBAAA;EAAA,eAAA;AJysBV;;AC3lBQ;ELoDF;IQ9ME,eAAA;IAAA,cAAA;EJ2vBN;EIxvBI;IAEI,eAAA;IAAA,cAAA;EJ0vBR;AACF;ACtmBQ;EGxII;IFoIR,oBATM;EFunBR;EIlvBU;IFoIR,qBATM;EF0nBR;EIrvBU;IFoIR,UATM;EF6nBR;EIxvBU;IFoIR,qBATM;EFgoBR;EI3vBU;IFoIR,qBATM;EFmoBR;EI9vBU;IFoIR,UATM;EFsoBR;EIjwBU;IFoIR,qBATM;EFyoBR;EIpwBU;IFoIR,qBATM;EF4oBR;EIvwBU;IFoIR,UATM;EF+oBR;EI1wBU;IFoIR,qBATM;EFkpBR;EI7wBU;IFoIR,qBATM;EFqpBR;EIhxBU;IFoIR,WATM;EFwpBR;AACF;AC5oBQ;EG/HI;IF2HR,oBATM;EF6pBR;EI/wBU;IF2HR,qBATM;EFgqBR;EIlxBU;IF2HR,UATM;EFmqBR;EIrxBU;IF2HR,qBATM;EFsqBR;EIxxBU;IF2HR,qBATM;EFyqBR;EI3xBU;IF2HR,UATM;EF4qBR;EI9xBU;IF2HR,qBATM;EF+qBR;EIjyBU;IF2HR,qBATM;EFkrBR;EIpyBU;IF2HR,UATM;EFqrBR;EIvyBU;IF2HR,qBATM;EFwrBR;EI1yBU;IF2HR,qBATM;EF2rBR;EI7yBU;IF2HR,WATM;EF8rBR;AACF;AClrBQ;EG/HI;IF2HR,oBATM;EFmsBR;EIrzBU;IF2HR,qBATM;EFssBR;EIxzBU;IF2HR,UATM;EFysBR;EI3zBU;IF2HR,qBATM;EF4sBR;EI9zBU;IF2HR,qBATM;EF+sBR;EIj0BU;IF2HR,UATM;EFktBR;EIp0BU;IF2HR,qBATM;EFqtBR;EIv0BU;IF2HR,qBATM;EFwtBR;EI10BU;IF2HR,UATM;EF2tBR;EI70BU;IF2HR,qBATM;EF8tBR;EIh1BU;IF2HR,qBATM;EFiuBR;EIn1BU;IF2HR,WATM;EFouBR;AACF;;ACxtBQ;EL0DF;IQ7KE,eAAA;IAAA,cAAA;EJi1BN;EI90BI;IAEI,gBAAA;IAAA,eAAA;EJg1BR;AACF;;ACnuBQ;ELoDF;IQ9ME,eAAA;IAAA,cAAA;EJm4BN;EIh4BI;IAEI,eAAA;IAAA,cAAA;EJk4BR;AACF;AC9uBQ;EGxII;IFoIR,oBATM;EF+vBR;EI13BU;IFoIR,qBATM;EFkwBR;EI73BU;IFoIR,UATM;EFqwBR;EIh4BU;IFoIR,qBATM;EFwwBR;EIn4BU;IFoIR,qBATM;EF2wBR;EIt4BU;IFoIR,UATM;EF8wBR;EIz4BU;IFoIR,qBATM;EFixBR;EI54BU;IFoIR,qBATM;EFoxBR;EI/4BU;IFoIR,UATM;EFuxBR;EIl5BU;IFoIR,qBATM;EF0xBR;EIr5BU;IFoIR,qBATM;EF6xBR;EIx5BU;IFoIR,WATM;EFgyBR;AACF;ACpxBQ;EGxII;IFoIR,oBATM;EFqyBR;EIh6BU;IFoIR,qBATM;EFwyBR;EIn6BU;IFoIR,UATM;EF2yBR;EIt6BU;IFoIR,qBATM;EF8yBR;EIz6BU;IFoIR,qBATM;EFizBR;EI56BU;IFoIR,UATM;EFozBR;EI/6BU;IFoIR,qBATM;EFuzBR;EIl7BU;IFoIR,qBATM;EF0zBR;EIr7BU;IFoIR,UATM;EF6zBR;EIx7BU;IFoIR,qBATM;EFg0BR;EI37BU;IFoIR,qBATM;EFm0BR;EI97BU;IFoIR,WATM;EFs0BR;AACF;AC1zBQ;EG/HI;IF2HR,oBATM;EF20BR;EI77BU;IF2HR,qBATM;EF80BR;EIh8BU;IF2HR,UATM;EFi1BR;EIn8BU;IF2HR,qBATM;EFo1BR;EIt8BU;IF2HR,qBATM;EFu1BR;EIz8BU;IF2HR,UATM;EF01BR;EI58BU;IF2HR,qBATM;EF61BR;EI/8BU;IF2HR,qBATM;EFg2BR;EIl9BU;IF2HR,UATM;EFm2BR;EIr9BU;IF2HR,qBATM;EFs2BR;EIx9BU;IF2HR,qBATM;EFy2BR;EI39BU;IF2HR,WATM;EF42BR;AACF;;ACh2BQ;EL0DF;IQ7KE,eAAA;IAAA,cAAA;EJy9BN;EIt9BI;IAEI,gBAAA;IAAA,eAAA;EJw9BR;AACF;;AJnyBM;ESlMF,eAAA;ALy+BJ;;AJnyBM;EStMF,mCAAA;AL6+BJ;;AJ3yBM;ESlMF,0BAAA;ALi/BJ;;AJ3yBM;EStMF,8CAAA;ALq/BJ;;AJnzBM;ESlMF,2BAAA;ALy/BJ;;AJnzBM;EStMF,+CAAA;AL6/BJ;;AJ3zBM;ESlMF,gBAAA;ALigCJ;;AJ3zBM;EStMF,oCAAA;ALqgCJ;;AJn0BM;ESlMF,2BAAA;ALygCJ;;AJn0BM;EStMF,+CAAA;AL6gCJ;;AJ30BM;ESlMF,2BAAA;ALihCJ;;AJ30BM;EStMF,+CAAA;ALqhCJ;;AJn1BM;ESlMF,gBAAA;ALyhCJ;;AJn1BM;EStMF,oCAAA;AL6hCJ;;AJ31BM;ESlMF,2BAAA;ALiiCJ;;AJ31BM;EStMF,+CAAA;ALqiCJ;;AJn2BM;ESlMF,2BAAA;ALyiCJ;;AJn2BM;EStMF,+CAAA;AL6iCJ;;AJ32BM;ESlMF,gBAAA;ALijCJ;;AJ32BM;EStMF,oCAAA;ALqjCJ;;AJn3BM;ESlMF,2BAAA;ALyjCJ;;AJn3BM;EStMF,+CAAA;AL6jCJ;;AJ33BM;ESlMF,2BAAA;ALikCJ;;AJ33BM;EStMF,+CAAA;ALqkCJ;;AC38BQ;ELwEF;ISlMF,eAAA;EL0kCF;EJp4BI;IStMF,oCAAA;EL6kCF;EJ34BI;ISlMF,0BAAA;ELglCF;EJ14BI;IStMF,+CAAA;ELmlCF;EJj5BI;ISlMF,2BAAA;ELslCF;EJh5BI;IStMF,gDAAA;ELylCF;EJv5BI;ISlMF,gBAAA;EL4lCF;EJt5BI;IStMF,qCAAA;EL+lCF;EJ75BI;ISlMF,2BAAA;ELkmCF;EJ55BI;IStMF,gDAAA;ELqmCF;EJn6BI;ISlMF,2BAAA;ELwmCF;EJl6BI;IStMF,gDAAA;EL2mCF;EJz6BI;ISlMF,gBAAA;EL8mCF;EJx6BI;IStMF,qCAAA;ELinCF;EJ/6BI;ISlMF,2BAAA;ELonCF;EJ96BI;IStMF,gDAAA;ELunCF;EJr7BI;ISlMF,2BAAA;EL0nCF;EJp7BI;IStMF,gDAAA;EL6nCF;EJ37BI;ISlMF,gBAAA;ELgoCF;EJ17BI;IStMF,qCAAA;ELmoCF;EJj8BI;ISlMF,2BAAA;ELsoCF;EJh8BI;IStMF,gDAAA;ELyoCF;EJv8BI;ISlMF,2BAAA;EL4oCF;EJt8BI;IStMF,gDAAA;EL+oCF;AACF;ACthCQ;ELwEF;ISlMF,eAAA;ELopCF;EJ98BI;IStMF,oCAAA;ELupCF;EJr9BI;ISlMF,0BAAA;EL0pCF;EJp9BI;IStMF,+CAAA;EL6pCF;EJ39BI;ISlMF,2BAAA;ELgqCF;EJ19BI;IStMF,gDAAA;ELmqCF;EJj+BI;ISlMF,gBAAA;ELsqCF;EJh+BI;IStMF,qCAAA;ELyqCF;EJv+BI;ISlMF,2BAAA;EL4qCF;EJt+BI;IStMF,gDAAA;EL+qCF;EJ7+BI;ISlMF,2BAAA;ELkrCF;EJ5+BI;IStMF,gDAAA;ELqrCF;EJn/BI;ISlMF,gBAAA;ELwrCF;EJl/BI;IStMF,qCAAA;EL2rCF;EJz/BI;ISlMF,2BAAA;EL8rCF;EJx/BI;IStMF,gDAAA;ELisCF;EJ//BI;ISlMF,2BAAA;ELosCF;EJ9/BI;IStMF,gDAAA;ELusCF;EJrgCI;ISlMF,gBAAA;EL0sCF;EJpgCI;IStMF,qCAAA;EL6sCF;EJ3gCI;ISlMF,2BAAA;ELgtCF;EJ1gCI;IStMF,gDAAA;ELmtCF;EJjhCI;ISlMF,2BAAA;ELstCF;EJhhCI;IStMF,gDAAA;ELytCF;AACF;AJlgCE;EC/OA,aAAA;EACA,wBAAA;AGovCF;AJlgCI;EMnIF,YAAA;EACA,gBAAA;AFwoCF;AJlgCI;EM1GA,YATM;AFwnCV;AJjgCI;EM9GA,YATM;AF2nCV;AJt/BM;EACE,gBAAA;AIw/BR;ACjnCQ;ELwHF;IACE,gBAAA;EI4/BN;AACF;ACtnCQ;ELwHF;IACE,gBAAA;EIigCN;AACF;AJt/BM;EMpLJ,cAAA;AF6qCF;AJ1+BQ;EMxJJ,qBATM;AF8oCV;AJ7+BQ;EMxJJ,sBATM;AFipCV;AJh/BQ;EMxJJ,WATM;AFopCV;AJn/BQ;EMxJJ,sBATM;AFupCV;AJt/BQ;EMxJJ,sBATM;AF0pCV;AJz/BQ;EMxJJ,WATM;AF6pCV;AJ5/BQ;EMxJJ,sBATM;AFgqCV;AJ//BQ;EMxJJ,sBATM;AFmqCV;AJlgCQ;EMxJJ,WATM;AFsqCV;AJrgCQ;EMxJJ,sBATM;AFyqCV;AJxgCQ;EMxJJ,sBATM;AF4qCV;AJ3gCQ;EMxJJ,YATM;AF+qCV;AClqCQ;ELgIA;IM/KN,WAAA;IA2CE,YATM;EForCR;EJliCI;IMpLJ,cAAA;EFytCA;EJ/hCM;IM/IJ,YATM;EF0rCR;EJzhCM;IMxJJ,qBATM;EF6rCR;EJ5hCM;IMxJJ,sBATM;EFgsCR;EJ/hCM;IMxJJ,WATM;EFmsCR;EJliCM;IMxJJ,sBATM;EFssCR;EJriCM;IMxJJ,sBATM;EFysCR;EJxiCM;IMxJJ,WATM;EF4sCR;EJ3iCM;IMxJJ,sBATM;EF+sCR;EJ9iCM;IMxJJ,sBATM;EFktCR;EJjjCM;IMxJJ,WATM;EFqtCR;EJpjCM;IMxJJ,sBATM;EFwtCR;EJvjCM;IMxJJ,sBATM;EF2tCR;EJ1jCM;IMxJJ,YATM;EF8tCR;AACF;ACltCQ;ELgIA;IM/KN,WAAA;IA2CE,YATM;EFouCR;EJllCI;IMpLJ,cAAA;EFywCA;EJ/kCM;IM/IJ,YATM;EF0uCR;EJzkCM;IMxJJ,qBATM;EF6uCR;EJ5kCM;IMxJJ,sBATM;EFgvCR;EJ/kCM;IMxJJ,WATM;EFmvCR;EJllCM;IMxJJ,sBATM;EFsvCR;EJrlCM;IMxJJ,sBATM;EFyvCR;EJxlCM;IMxJJ,WATM;EF4vCR;EJ3lCM;IMxJJ,sBATM;EF+vCR;EJ9lCM;IMxJJ,sBATM;EFkwCR;EJjmCM;IMxJJ,WATM;EFqwCR;EJpmCM;IMxJJ,sBATM;EFwwCR;EJvmCM;IMxJJ,sBATM;EF2wCR;EJ1mCM;IMxJJ,YATM;EF8wCR;AACF;;AJlmCM;EGnTE,qBAAA;EAAA,wBAAA;AC05CR;ACvwCQ;ELgKF;IGnTE,sBAAA;IAAA,yBAAA;EC+5CN;AACF;AJxmCM;EGxTE,qBAAA;EAAA,wBAAA;ACo6CR;ACjxCQ;ELqKF;IGxTE,sBAAA;IAAA,yBAAA;ECy6CN;AACF;;AJn0CE;EGvGM,qBAAA;EAAA,wBAAA;AC+6CR;AC5xCQ;EL5CN;IGvGM,sBAAA;IAAA,yBAAA;ECo7CN;AACF;AJ10CI;EMoCA,4BATM;EH7HJ,oBAAA;EAAA,uBAAA;ACi7CN;ACvyCQ;ELjCA;IM6BJ,6BATM;IH7HJ,qBAAA;IAAA,wBAAA;ECu7CJ;AACF;AJl3CE;EMgEE,YATM;AF8zCV;AJj3CE;EM4DE,YATM;AFi0CV;AJ52CI;EMoDA,qCATM;AFo0CV;AJ/2CI;EMoDA,sCATM;AFu0CV;AJl3CI;EMoDA,2BATM;AF00CV;AJr3CI;EMoDA,sCATM;AF60CV;AJx3CI;EMoDA,sCATM;AFg1CV;AJ33CI;EMoDA,2BATM;AFm1CV;AJ93CI;EMoDA,sCATM;AFs1CV;AJj4CI;EMoDA,sCATM;AFy1CV;AJp4CI;EMoDA,2BATM;AF41CV;AJv4CI;EMoDA,sCATM;AF+1CV;AJ14CI;EMoDA,sCATM;AFk2CV;AJ74CI;EMoDA,4BATM;AFq2CV;ACx1CQ;ELpEN;IMgEE,YATM;EFy2CR;EJ55CA;IM4DE,YATM;EF42CR;EJv5CE;IMoDA,sCATM;EF+2CR;EJ15CE;IMoDA,uCATM;EFk3CR;EJ75CE;IMoDA,4BATM;EFq3CR;EJh6CE;IMoDA,uCATM;EFw3CR;EJn6CE;IMoDA,uCATM;EF23CR;EJt6CE;IMoDA,4BATM;EF83CR;EJz6CE;IMoDA,uCATM;EFi4CR;EJ56CE;IMoDA,uCATM;EFo4CR;EJ/6CE;IMoDA,4BATM;EFu4CR;EJl7CE;IMoDA,uCATM;EF04CR;EJr7CE;IMoDA,uCATM;EF64CR;EJx7CE;IMoDA,6BATM;EFg5CR;EJv8CA;IMgEE,YATM;EFm5CR;EJt8CA;IM4DE,YATM;EFs5CR;EJj8CE;IMoDA,sCATM;EFy5CR;EJp8CE;IMoDA,uCATM;EF45CR;EJv8CE;IMoDA,4BATM;EF+5CR;EJ18CE;IMoDA,uCATM;EFk6CR;EJ78CE;IMoDA,uCATM;EFq6CR;EJh9CE;IMoDA,4BATM;EFw6CR;EJn9CE;IMoDA,uCATM;EF26CR;EJt9CE;IMoDA,uCATM;EF86CR;EJz9CE;IMoDA,4BATM;EFi7CR;EJ59CE;IMoDA,uCATM;EFo7CR;EJ/9CE;IMoDA,uCATM;EFu7CR;EJl+CE;IMoDA,6BATM;EF07CR;AACF;AC96CQ;ELpEN;IMgEE,YATM;EF+7CR;EJl/CA;IM4DE,YATM;EFk8CR;EJ7+CE;IMoDA,sCATM;EFq8CR;EJh/CE;IMoDA,uCATM;EFw8CR;EJn/CE;IMoDA,4BATM;EF28CR;EJt/CE;IMoDA,uCATM;EF88CR;EJz/CE;IMoDA,uCATM;EFi9CR;EJ5/CE;IMoDA,4BATM;EFo9CR;EJ//CE;IMoDA,uCATM;EFu9CR;EJlgDE;IMoDA,uCATM;EF09CR;EJrgDE;IMoDA,4BATM;EF69CR;EJxgDE;IMoDA,uCATM;EFg+CR;EJ3gDE;IMoDA,uCATM;EFm+CR;EJ9gDE;IMoDA,6BATM;EFs+CR;AACF;;AJvyCE;EUpVE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EAqCI,YAAA;AN2lDR;;AJ3yCE;EACE,WAAA;AI8yCJ;;AJ3yCE;EUjSE,gBAAA;EACA,eAAA;EAGF,iCAAA;EACA,4CAAA;AN8kDF;;AJ9yCE;EUzSE,gBAAA;EACA,gBAAA;EACA,gBAAA;EAMF,iCAAA;EACA,4CAAA;ANslDF;;AJjzCE;EU9RA,aAAA;EACA,sBAAA;EACA,gBAAA;ANmlDF;AMjlDE;EACE,gBAAA;EACA,iBAAA;ANmlDJ;;AC//CQ;EL2MJ;IU5WA,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IAqCI,YAAA;ENioDN;EJzzCE;IACE,WAAA;EI2zCJ;EJxzCE;IUzTA,gBAAA;IACA,eAAA;IAGF,iCAAA;IACA,4CAAA;ENknDA;EJ1zCE;IUjTF,aAAA;IACA,sBAAA;IACA,gBAAA;EN8mDA;EM5mDA;IACE,gBAAA;IACA,iBAAA;EN8mDF;EJ/zCE;IUrUA,gBAAA;IACA,gBAAA;IACA,gBAAA;IAMF,iCAAA;IACA,4CAAA;ENkoDA;AACF;ACliDQ;EL2MJ;IU5WA,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IAqCI,YAAA;ENmqDN;EJ31CE;IACE,WAAA;EI61CJ;EJ11CE;IUzTA,gBAAA;IACA,eAAA;IAGF,iCAAA;IACA,4CAAA;ENopDA;EJ51CE;IUjTF,aAAA;IACA,sBAAA;IACA,gBAAA;ENgpDA;EM9oDA;IACE,gBAAA;IACA,iBAAA;ENgpDF;EJj2CE;IUrUA,gBAAA;IACA,gBAAA;IACA,gBAAA;IAMF,iCAAA;IACA,4CAAA;ENoqDA;AACF;AJl2CM;EUnYF,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EAmCI,aAAA;EV+VA,WAAA;AIw2CR;AC5kDQ;ELwOA;IUzYJ,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IAmCI,aAAA;IVqWE,WAAA;EI22CR;AACF;ACtlDQ;ELwOA;IUzYJ,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;IAmCI,aAAA;IVqWE,WAAA;EIq3CR;AACF;;AJh3CM;EACE,YAAA;AIm3CR;ACpmDQ;ELoPA;IACE,YAAA;EIm3CR;AACF;ACzmDQ;ELoPA;IACE,YAAA;EIw3CR;AACF;;AJ1pDE;EGvGM,qBAAA;EAAA,wBAAA;ACswDR;ACnnDQ;EL5CN;IGvGM,sBAAA;IAAA,yBAAA;EC2wDN;AACF;AJjqDI;EMoCA,4BATM;EH7HJ,oBAAA;EAAA,uBAAA;ACwwDN;AC9nDQ;ELjCA;IM6BJ,6BATM;IH7HJ,qBAAA;IAAA,wBAAA;EC8wDJ;AACF;AJzsDE;EMgEE,YATM;AFqpDV;AJxsDE;EM4DE,YATM;AFwpDV;AJnsDI;EMoDA,qCATM;AF2pDV;AJtsDI;EMoDA,sCATM;AF8pDV;AJzsDI;EMoDA,2BATM;AFiqDV;AJ5sDI;EMoDA,sCATM;AFoqDV;AJ/sDI;EMoDA,sCATM;AFuqDV;AJltDI;EMoDA,2BATM;AF0qDV;AJrtDI;EMoDA,sCATM;AF6qDV;AJxtDI;EMoDA,sCATM;AFgrDV;AJ3tDI;EMoDA,2BATM;AFmrDV;AJ9tDI;EMoDA,sCATM;AFsrDV;AJjuDI;EMoDA,sCATM;AFyrDV;AJpuDI;EMoDA,4BATM;AF4rDV;AC/qDQ;ELpEN;IMgEE,YATM;EFgsDR;EJnvDA;IM4DE,YATM;EFmsDR;EJ9uDE;IMoDA,sCATM;EFssDR;EJjvDE;IMoDA,uCATM;EFysDR;EJpvDE;IMoDA,4BATM;EF4sDR;EJvvDE;IMoDA,uCATM;EF+sDR;EJ1vDE;IMoDA,uCATM;EFktDR;EJ7vDE;IMoDA,4BATM;EFqtDR;EJhwDE;IMoDA,uCATM;EFwtDR;EJnwDE;IMoDA,uCATM;EF2tDR;EJtwDE;IMoDA,4BATM;EF8tDR;EJzwDE;IMoDA,uCATM;EFiuDR;EJ5wDE;IMoDA,uCATM;EFouDR;EJ/wDE;IMoDA,6BATM;EFuuDR;EJ9xDA;IMgEE,YATM;EF0uDR;EJ7xDA;IM4DE,YATM;EF6uDR;EJxxDE;IMoDA,sCATM;EFgvDR;EJ3xDE;IMoDA,uCATM;EFmvDR;EJ9xDE;IMoDA,4BATM;EFsvDR;EJjyDE;IMoDA,uCATM;EFyvDR;EJpyDE;IMoDA,uCATM;EF4vDR;EJvyDE;IMoDA,4BATM;EF+vDR;EJ1yDE;IMoDA,uCATM;EFkwDR;EJ7yDE;IMoDA,uCATM;EFqwDR;EJhzDE;IMoDA,4BATM;EFwwDR;EJnzDE;IMoDA,uCATM;EF2wDR;EJtzDE;IMoDA,uCATM;EF8wDR;EJzzDE;IMoDA,6BATM;EFixDR;AACF;ACrwDQ;ELpEN;IMgEE,YATM;EFsxDR;EJz0DA;IM4DE,YATM;EFyxDR;EJp0DE;IMoDA,sCATM;EF4xDR;EJv0DE;IMoDA,uCATM;EF+xDR;EJ10DE;IMoDA,4BATM;EFkyDR;EJ70DE;IMoDA,uCATM;EFqyDR;EJh1DE;IMoDA,uCATM;EFwyDR;EJn1DE;IMoDA,4BATM;EF2yDR;EJt1DE;IMoDA,uCATM;EF8yDR;EJz1DE;IMoDA,uCATM;EFizDR;EJ51DE;IMoDA,4BATM;EFozDR;EJ/1DE;IMoDA,uCATM;EFuzDR;EJl2DE;IMoDA,uCATM;EF0zDR;EJr2DE;IMoDA,6BATM;EF6zDR;AACF;;AJrjDI;EUrYI,6BAAA;AN87DR;ACrzDQ;EL4PJ;IUrYI,8BAAA;ENk8DN;AACF;AC1zDQ;EL4PJ;IUrYI,8BAAA;ENu8DN;AACF;;AC/zDQ;ELgQF;IUzYE,8BAAA;EN68DN;AACF;ACr0DQ;ELgQF;IUzYE,8BAAA;ENk9DN;AACF;AAp/DA;EAsDI,WAAA;AAi8DJ;AAr/DI;;EAGQ,aAAA;EAeJ,mBAAA;EACA,mBF8CQ;EE7CR,cAAA;EACA,WAAA;AAw+DR;ACr1DQ;EDxKJ;;IAOQ,kBAAA;EA2/DV;AACF;AC31DQ;EDxKJ;;IAWQ,mBAAA;EA6/DV;AACF;AC51DQ;ED7KJ;;IAeQ,mBAAA;EA+/DV;AACF;AAx/DQ;;;;EAEI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,eAAA;AA4/DZ;AAz/DQ;;EACI,WAAA;EACA,cAAA;EACA,eAAA;AA4/DZ;AAx/DI;EAEQ,WAAA;AAy/DZ;ACz3DQ;EDlIJ;IAMQ,WAAA;EAy/DV;AACF;AC93DQ;EDlIJ;IAUQ,iBAAA;EA0/DV;AACF;;AAn/DA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AAs/DJ;;AAl/DA;EACI,eAAA;EACA,WAAA;AAq/DJ;;AAj/DA;EACI,iBAAA;EAKA,kBAAA;EACA,mBAAA;AAg/DJ;ACp5DQ;EDnGR;IAGQ,kBAAA;EAw/DN;AACF;;AAl/DA;EACI,aAAA;EACA,oDAAA;AAq/DJ;AAn/DI;EACI,cAAA;EACA,WAAA;AAq/DR;AAn/DI;EACI,iBAAA;EACA,aAAA;AAq/DR;AAn/DQ;EACI,YAAA;EACA,kBAAA;EACA,aAAA;AAq/DZ;AAl/DQ;EACI,eAAA;AAo/DZ;;AA/+DA;EACI,aAAA;EACA,sBAAA;AAk/DJ;;AA/+DI;EACI,YAAA;AAk/DR","sourcesContent":["/**\n * Foundation for Sites\n * Version 6.9.0\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n\n// --- Dependencies ---\n@import 'vendor/normalize';\n@import '../_vendor/sassy-lists/stylesheets/helpers/missing-dependencies';\n@import '../_vendor/sassy-lists/stylesheets/helpers/true';\n@import '../_vendor/sassy-lists/stylesheets/functions/contain';\n@import '../_vendor/sassy-lists/stylesheets/functions/purge';\n@import '../_vendor/sassy-lists/stylesheets/functions/remove';\n@import '../_vendor/sassy-lists/stylesheets/functions/replace';\n@import '../_vendor/sassy-lists/stylesheets/functions/to-list';\n\n// --- Settings ---\n// import your own `settings` here or\n// import and modify the default settings through\n// @import 'settings/settings';\n\n// --- Components ---\n// Utilities\n@import 'util/util';\n// Global styles\n@import 'global';\n@import 'forms/forms';\n@import 'typography/typography';\n\n// Grids\n@import 'grid/grid';\n@import 'xy-grid/xy-grid';\n// Generic components\n@import 'components/button';\n@import 'components/button-group';\n@import 'components/close-button';\n@import 'components/label';\n@import 'components/progress-bar';\n@import 'components/slider';\n@import 'components/switch';\n@import 'components/table';\n// Basic components\n@import 'components/badge';\n@import 'components/breadcrumbs';\n@import 'components/callout';\n@import 'components/card';\n@import 'components/dropdown';\n@import 'components/pagination';\n@import 'components/tooltip';\n\n// Containers\n@import 'components/accordion';\n@import 'components/media-object';\n@import 'components/orbit';\n@import 'components/responsive-embed';\n@import 'components/tabs';\n@import 'components/thumbnail';\n// Menu-based containers\n@import 'components/menu';\n@import 'components/menu-icon';\n@import 'components/accordion-menu';\n@import 'components/drilldown';\n@import 'components/dropdown-menu';\n\n// Layout components\n@import 'components/off-canvas';\n@import 'components/reveal';\n@import 'components/sticky';\n@import 'components/title-bar';\n@import 'components/top-bar';\n\n// Helpers\n@import 'components/float';\n@import 'components/flex';\n@import 'components/visibility';\n@import 'prototype/prototype';\n\n\n@mixin foundation-everything(\n  $flex: true,\n  $prototype: false,\n  $xy-grid: $xy-grid\n) {\n  @if $flex {\n    $global-flexbox: true !global;\n  }\n\n  @if $xy-grid {\n    $xy-grid: true !global;\n  }\n\n  // Global styles\n  @include foundation-global-styles;\n  @include foundation-forms;\n  @include foundation-typography;\n\n  // Grids\n  @if not $flex {\n    @include foundation-grid;\n  }\n  @else {\n    @if $xy-grid {\n      @include foundation-xy-grid-classes;\n    }\n    @else {\n      @include foundation-flex-grid;\n    }\n  }\n\n  // Generic components\n  @include foundation-button;\n  @include foundation-button-group;\n  @include foundation-close-button;\n  @include foundation-label;\n  @include foundation-progress-bar;\n  @include foundation-slider;\n  @include foundation-switch;\n  @include foundation-table;\n  // Basic components\n  @include foundation-badge;\n  @include foundation-breadcrumbs;\n  @include foundation-callout;\n  @include foundation-card;\n  @include foundation-dropdown;\n  @include foundation-pagination;\n  @include foundation-tooltip;\n\n  // Containers\n  @include foundation-accordion;\n  @include foundation-media-object;\n  @include foundation-orbit;\n  @include foundation-responsive-embed;\n  @include foundation-tabs;\n  @include foundation-thumbnail;\n  // Menu-based containers\n  @include foundation-menu;\n  @include foundation-menu-icon;\n  @include foundation-accordion-menu;\n  @include foundation-drilldown-menu;\n  @include foundation-dropdown-menu;\n\n  // Layout components\n  @include foundation-off-canvas;\n  @include foundation-reveal;\n  @include foundation-sticky;\n  @include foundation-title-bar;\n  @include foundation-top-bar;\n\n  // Helpers\n  @include foundation-float-classes;\n  @if $flex { @include foundation-flex-classes; }\n  @include foundation-visibility-classes;\n  @if $prototype { @include foundation-prototype-classes; }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n// Margin Grid classes\n@mixin xy-base-grid-classes {\n\n  // Grid Container\n  .grid-container {\n    @include xy-grid-container;\n\n    &.fluid {\n      @include xy-grid-container(100%);\n    }\n\n    &.full {\n      @include xy-grid-container(100%, 0);\n    }\n  }\n\n  // Base grid styles\n  .grid-x {\n    @include xy-grid;\n  }\n\n  .cell {\n    @include xy-cell(full, $gutter-type: none);\n\n    &.auto {\n      @include xy-cell-base(auto);\n    }\n\n    &.shrink {\n      @include xy-cell-base(shrink);\n    }\n\n  }\n  .grid-x {\n    > .auto {\n      @include xy-cell-size(auto, $gutter-type: none);\n    }\n\n    > .shrink {\n      @include xy-cell-size(shrink, $gutter-type: none);\n    }\n  }\n\n  // Auto width\n  @include -zf-each-breakpoint() {\n    // This is a bit of a hack/workaround, see these issues & PRs for the backstory:\n    // https://github.com/foundation/foundation-sites/issues/10244\n    // https://github.com/foundation/foundation-sites/pull/10222 and\n    // https://github.com/foundation/foundation-sites/pull/10164\n    .grid-x {\n      $str: \"> .#{$-zf-size}-shrink, > .#{$-zf-size}-full\";\n      @for $i from 1 through $grid-columns {\n        $str: $str + \", > .#{$-zf-size}-#{$i}\";\n      }\n      #{$str} {\n        flex-basis: auto;\n      }\n    }\n  }\n\n  @include -zf-each-breakpoint() {\n    // Responsive \"auto\" modifier\n    @if not($-zf-size == $-zf-zero-breakpoint) {\n      .grid-x > .#{$-zf-size}-auto {\n        @include xy-cell(auto, $gutter-type: none);\n      }\n    }\n\n    %-xy-cell-base-shrink-horizontal-#{$-zf-size} {\n      @include xy-cell-base(shrink);\n    }\n\n    // Responsive \"shrink\" modifier\n    @if not($-zf-size == $-zf-zero-breakpoint) {\n      .grid-x > .#{$-zf-size}-shrink {\n        @extend %-xy-cell-base-shrink-horizontal-#{$-zf-size};\n        @include xy-cell-size(shrink, $gutter-type: none);\n      }\n    }\n\n    // Responsive width modifiers\n    @for $i from 1 through $grid-columns {\n      // Sizing (percentage)\n      .grid-x > .#{$-zf-size}-#{$i} {\n        @extend %-xy-cell-base-shrink-horizontal-#{$-zf-size};\n        @include xy-cell-size($i, $gutter-type: none);\n      }\n    }\n  }\n\n  // Reset width when using `.grid-margin-x` not on `.grid-x`\n  .grid-margin-x:not(.grid-x) > .cell {\n    width: auto;\n  }\n\n  // Reset height when using `.grid-margin-y` not on `.grid-y`\n  .grid-margin-y:not(.grid-y) > .cell {\n    height: auto;\n  }\n}\n\n@mixin -xy-breakpoint-cell-classes($class-breakpoint, $gutter-breakpoint, $vertical) {\n  $prefix: if($class-breakpoint == $-zf-zero-breakpoint, '', '#{$class-breakpoint}-');\n  > .#{$prefix}auto {\n    @include xy-cell-size(auto, $vertical: $vertical);\n  }\n\n  > .#{$prefix}shrink {\n    @include xy-cell-size(shrink, $vertical: $vertical);\n  }\n\n  @for $i from 1 through $grid-columns {\n    // Sizing (percentage)\n    $classname: if($vertical, '.#{$class-breakpoint}-#{$i}', '.#{$class-breakpoint}-#{$i}');\n\n    > #{$classname} {\n      @include xy-cell-size($i, $vertical: $vertical);\n    }\n  }\n}\n\n// Margin Grid classes\n@mixin xy-margin-grid-classes(\n  $gutter-position: left right,\n  $vertical: false,\n  $wrapping-selector: '.grid-margin-x'\n){\n  #{$wrapping-selector} {\n    @include xy-gutters($negative: true, $gutter-position: $gutter-position);\n\n    // Base cell styles\n    > .cell {\n      @include xy-cell($vertical: $vertical, $output: (size gutters));\n    }\n\n    // base styles need to all be before the auto and shrink styles\n    @include -zf-each-breakpoint() {\n      @if(type-of($grid-margin-gutters) == 'map' and map-has-key($grid-margin-gutters, $-zf-size) and $-zf-size != $-zf-zero-breakpoint) {\n        > .cell {\n          @include xy-cell($vertical: $vertical, $output: (size gutters));\n        }\n      }\n    }\n\n    @include -zf-each-breakpoint() {\n\n      // This is purely for responsive gutters - the margin grid has to go back and adjust widths (or heights)\n      // for all prior breakpoints.\n      // As their gutter is defined with their width/height, even breakpoint without a new margin must be\n      // generated to not having their width/height overrided by re-adjusted smaller breakpoints.\n      @if(type-of($grid-margin-gutters) == 'map' and map-has-key($grid-margin-gutters, $-zf-size)) {\n        @each $bp in -zf-breakpoints-less-than($-zf-size) {\n          @include -xy-breakpoint-cell-classes($bp, $-zf-size, $vertical);\n        }\n      }\n\n      @include -xy-breakpoint-cell-classes($-zf-size, $-zf-size, $vertical);\n    }\n  }\n}\n\n// Padding Grid classes\n@mixin xy-padding-grid-classes {\n  .grid-padding-x {\n\n    // Negative margin for nested grids\n    .grid-padding-x {\n      @include xy-gutters($negative: true);\n    }\n\n    // Negative margin for grids within `grid-container/grid-container.fluid`\n    // This allows margin and padding grids to line up with eachother\n    .grid-container:not(.full) > & {\n      @include xy-gutters($negative: true);\n    }\n\n    // Base cell styles\n    > .cell {\n      @include xy-gutters($gutters: $grid-padding-gutters, $gutter-type: padding);\n    }\n  }\n}\n\n// Block Grid classes\n@mixin xy-block-grid-classes($margin-grid: true, $padding-grid: true) {\n  @if $padding-grid {\n    @include -zf-each-breakpoint {\n      @for $i from 1 through $xy-block-grid-max {\n        .#{$-zf-size}-up-#{$i} {\n          @include xy-grid-layout($n: $i, $selector: '.cell', $gutter-type: padding, $output: (size));\n        }\n      }\n    }\n  }\n\n  @if $margin-grid {\n    @include -zf-each-breakpoint {\n      @for $i from 1 through $xy-block-grid-max {\n        // This is purely for responsive gutters - the margin grid has to go back and adjust widths (or heights)\n        // for prior breakpoints based on the responsive gutter.\n        @if(type-of($grid-margin-gutters) == 'map' and map-has-key($grid-margin-gutters, $-zf-size)) {\n          @each $bp in -zf-breakpoints-less-than($-zf-size) {\n            @if(map-has-key($grid-margin-gutters, $bp)) {\n              .grid-margin-x.#{$bp}-up-#{$i} {\n                @include xy-grid-layout($n: $i, $selector: '.cell', $gutter-type: margin, $output: (size));\n              }\n            }\n          }\n        }\n      }\n      @for $i from 1 through $xy-block-grid-max {\n        .grid-margin-x.#{$-zf-size}-up-#{$i} {\n          @include xy-grid-layout($n: $i, $selector: '.cell', $gutter-type: margin, $output: (size));\n        }\n      }\n    }\n  }\n}\n\n// Collapse classes\n@mixin xy-collapse-grid-classes($margin-grid: true, $padding-grid: true) {\n  @each $bp in $breakpoint-classes {\n    @if $margin-grid {\n      .#{$bp}-margin-collapse {\n        @include xy-grid-collapse($gutter-type: margin, $min-breakpoint: $bp);\n      }\n    }\n\n    @if $padding-grid {\n      .#{$bp}-padding-collapse {\n        @include xy-grid-collapse($gutter-type: padding, $min-breakpoint: $bp);\n      }\n    }\n  }\n}\n\n// Offset classes\n@mixin xy-offset-cell-classes {\n  @include -zf-each-breakpoint {\n    @for $i from 1 through $grid-columns {\n      // Offsets\n      $o: $i - 1;\n\n      .#{$-zf-size}-offset-#{$o} {\n        @include xy-cell-offset($o, $gutters: $grid-padding-gutters, $gutter-type: padding);\n      }\n\n      .grid-margin-x > .#{$-zf-size}-offset-#{$o} {\n        @include xy-cell-offset($o);\n      }\n    }\n  }\n}\n\n// Vertical Grid classes\n@mixin xy-vertical-grid-classes(\n  $margin-grid: true,\n  $padding-grid: true\n) {\n\n  // @include -zf-each-breakpoint() {\n  //   @if not($-zf-size == $-zf-zero-breakpoint) {\n  //   }\n  // }\n\n  .grid-y {\n    @include xy-grid(vertical, false);\n\n\n    > .cell {\n      @include xy-cell-reset();\n    }\n\n    > .auto {\n      @include xy-cell-size(auto, $gutter-type: none, $vertical: true);\n    }\n\n    > .shrink {\n      @include xy-cell-size(shrink, $gutter-type: none, $vertical: true);\n    }\n\n\n    @include -zf-each-breakpoint() {\n      // This is a bit of a hack/workaround, see these issues and PRs for the backstory:\n      // https://github.com/foundation/foundation-sites/issues/10244\n      // https://github.com/foundation/foundation-sites/pull/10222 and\n      // https://github.com/foundation/foundation-sites/pull/10164\n      $str: \"> .#{$-zf-size}-shrink, > .#{$-zf-size}-full\";\n      @for $i from 1 through $grid-columns {\n        $str: $str + \", > .#{$-zf-size}-#{$i}\";\n      }\n      #{$str} {\n        flex-basis: auto;\n      }\n    }\n\n    @include -zf-each-breakpoint() {\n      // Responsive \"auto\" modifier\n      @if not($-zf-size == $-zf-zero-breakpoint) {\n        > .#{$-zf-size}-auto {\n          @include xy-cell(auto, $gutter-type: none, $vertical: true);\n        }\n      }\n\n      %-xy-cell-base-shrink-vertical-#{$-zf-size} {\n        @include xy-cell-base(shrink);\n      }\n\n      // Responsive \"shrink\" modifier\n      @if not($-zf-size == $-zf-zero-breakpoint) {\n        > .#{$-zf-size}-shrink {\n          @extend %-xy-cell-base-shrink-vertical-#{$-zf-size};\n          @include xy-cell-size(shrink, $gutter-type: none, $vertical: true);\n        }\n      }\n\n      // Responsive width modifiers\n      @for $i from 1 through $grid-columns {\n        // Sizing (percentage)\n        > .#{$-zf-size}-#{$i} {\n          @extend %-xy-cell-base-shrink-vertical-#{$-zf-size};\n          @include xy-cell-size($i, $gutter-type: none, $vertical: true);\n        }\n      }\n\n    }\n  }\n\n  @if $padding-grid {\n    .grid-padding-y {\n      // Negative margin for nested grids\n      .grid-padding-y {\n        @include xy-gutters($negative: true, $gutter-position: top bottom);\n      }\n\n      // Base cell styles\n      > .cell {\n        @include xy-gutters($gutters: $grid-padding-gutters, $gutter-type: padding, $gutter-position: top bottom);\n      }\n    }\n  }\n\n  @if $margin-grid {\n    @include xy-margin-grid-classes(top bottom, true, '.grid-margin-y');\n  }\n\n}\n\n@mixin xy-frame-grid-classes($vertical-grid: true, $margin-grid: true) {\n  // Framed grid styles\n  .grid-frame {\n    @include xy-grid-frame;\n  }\n\n  .cell .grid-frame {\n    width: 100%; // Same as include with $nested, but with less css\n  }\n\n  .cell-block {\n    @include xy-cell-block();\n  }\n\n  .cell-block-y {\n    @include xy-cell-block(true);\n  }\n\n\n  .cell-block-container {\n    @include xy-cell-block-container();\n  }\n\n\n  @include -zf-each-breakpoint(false) {\n\n    .#{$-zf-size}-grid-frame {\n      @include xy-grid-frame;\n    }\n\n    .cell .#{$-zf-size}-grid-frame {\n      width: 100%; // Same as include with $nested, but with less css\n    }\n\n    .#{$-zf-size}-cell-block {\n      @include xy-cell-block();\n    }\n\n    .#{$-zf-size}-cell-block-container {\n      @include xy-cell-block-container();\n    }\n\n    .#{$-zf-size}-cell-block-y {\n      @include xy-cell-block(true);\n    }\n  }\n\n  @if $vertical-grid {\n    .grid-y {\n      &.grid-frame {\n        @include xy-grid-frame(true);\n        width: auto;\n      }\n\n      @include -zf-each-breakpoint(false) {\n        &.#{$-zf-size}-grid-frame {\n          @include xy-grid-frame(true);\n          width: auto;\n        }\n\n      }\n    }\n    .cell {\n      .grid-y.grid-frame {\n        height: 100%; // Same as include with $nested, but with less css\n      }\n      @include -zf-each-breakpoint(false) {\n        .grid-y.#{$-zf-size}-grid-frame {\n          height: 100%; // Same as include with $nested, but with less css\n        }\n      }\n    }\n  }\n  @if $margin-grid {\n    @include xy-margin-grid-classes(top bottom, true, '.grid-margin-y');\n    .grid-frame.grid-margin-y {\n      @include xy-grid-frame(true, false, $grid-margin-gutters, $include-base: false);\n    }\n    @include -zf-each-breakpoint(false) {\n      .grid-margin-y.#{$-zf-size}-grid-frame {\n        @include xy-grid-frame(true, false, $grid-margin-gutters, $-zf-size, false);\n      }\n    }\n  }\n}\n\n// Final classes\n@mixin foundation-xy-grid-classes(\n  $base-grid: true,\n  $margin-grid: true,\n  $padding-grid: true,\n  $block-grid: true,\n  $collapse: true,\n  $offset: true,\n  $vertical-grid: true,\n  $frame-grid: true\n) {\n\n  // Base grid styles\n  @if($base-grid) {\n    @include xy-base-grid-classes();\n  }\n\n  // Margin grid\n  @if($margin-grid) {\n    @include xy-margin-grid-classes();\n  }\n\n  // Padding grid\n  @if($padding-grid) {\n    @include xy-padding-grid-classes();\n  }\n\n  // Block grid\n  @if($block-grid) {\n    @include xy-block-grid-classes($margin-grid, $padding-grid);\n  }\n\n  // Collapse gutters\n  @if($collapse) {\n    @include xy-collapse-grid-classes($margin-grid, $padding-grid);\n  }\n\n  // Offset gutters\n  @if($offset) {\n    @include xy-offset-cell-classes();\n  }\n\n  // Vertical grid\n  @if($vertical-grid) {\n    @include xy-vertical-grid-classes($margin-grid, $padding-grid);\n  }\n\n  @if ($frame-grid) {\n    @include xy-frame-grid-classes($vertical-grid, $margin-grid)\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Creates a max width container, designed to house your grid content.\n///\n/// @param {Number} $width [$grid-container] - a width to limit the container to.\n/// @param {Number} $padding [$grid-container-padding] - paddings of the container.\n@mixin xy-grid-container(\n  $width: $grid-container,\n  $padding: $grid-container-padding\n) {\n  max-width: $width;\n  margin-left: auto;\n  margin-right: auto;\n\n  @include xy-gutters($gutters: $padding, $gutter-type: padding);\n}\n\n/// Creates a container for your flex cells.\n///\n/// @param {Keyword} $direction [horizontal] - Either horizontal or vertical direction of cells within.\n/// @param {Boolean} $wrap [true] - If the cells within should wrap or not.\n@mixin xy-grid(\n  $direction: horizontal,\n  $wrap: true\n) {\n  $direction: if($direction == 'horizontal', row, column);\n  $wrap: if($wrap, wrap, nowrap);\n\n  display: flex;\n  flex-flow: $direction $wrap;\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n// sass-lint:disable no-color-literals, no-qualifying-elements\n\n////\n/// @group global\n////\n\n@import 'util/util';\n\n/// Font size attribute applied to `<html>` and `<body>`. We use 100% by default so the value is inherited from the user's browser settings.\n/// @type Number\n$global-font-size: 100% !default;\n\n/// Global width of your site. Used by the grid to determine row width.\n/// @type Number\n$global-width: rem-calc(1200) !default;\n\n/// Default line height for all type. `$global-lineheight` is 24px while `$global-font-size` is 16px\n/// @type Number\n$global-lineheight: 1.5 !default;\n\n/// Colors used for buttons, callouts, links, etc. There must always be a color called `primary`.\n/// @type Map\n$foundation-palette: (\n  \"primary\": #1779ba,\n  \"secondary\": #767676,\n  \"success\": #3adb76,\n  \"warning\": #ffae00,\n  \"alert\": #cc4b37,\n) !default;\n\n/// Color used for light gray UI items.\n/// @type Color\n$light-gray: #e6e6e6 !default;\n\n/// Color used for medium gray UI items.\n/// @type Color\n$medium-gray: #cacaca !default;\n\n/// Color used for dark gray UI items.\n/// @type Color\n$dark-gray: #8a8a8a !default;\n\n/// Color used for black ui items.\n/// @type Color\n$black: #0a0a0a !default;\n\n/// Color used for white ui items.\n/// @type Color\n$white: #fefefe !default;\n\n/// Background color of the body.\n/// @type Color\n$body-background: $white !default;\n\n/// Text color of the body.\n/// @type Color\n$body-font-color: $black !default;\n\n/// Font stack of the body.\n/// @type List\n$body-font-family: 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif !default;\n\n/// Set to `true` to enable safe padding on the body for non-rectangular devices (i.e. phones with notches)\n/// @type Boolean\n$body-safe-padding: false !default;\n\n/// Set to `true` to enable antialiased type, using the `-webkit-font-smoothing` and `-moz-osx-font-smoothing` CSS properties.\n/// @type Boolean\n$body-antialiased: true !default;\n\n/// Global value used for margin on components.\n/// @type Number\n$global-margin: 1rem !default;\n\n/// Global value used for padding on components.\n/// @type Number\n$global-padding: 1rem !default;\n\n/// Global value used for positioning on components.\n/// @type Number\n$global-position: 1rem !default;\n\n/// Global font weight used for normal type.\n/// @type Keyword | Number\n$global-weight-normal: normal !default;\n\n/// Global font weight used for bold type.\n/// @type Keyword | Number\n$global-weight-bold: bold !default;\n\n/// Global value used for all elements that have a border radius.\n/// @type Number\n$global-radius: 0 !default;\n\n/// Global value used for all menu styles. Can be overwritten at individual menu component level.\n/// @type Number\n$global-menu-padding: 0.7rem 1rem !default;\n\n/// Global value used for all menu styles. Nested margin for submenu.\n$global-menu-nested-margin: 1rem !default;\n\n/// Sets the text direction of the CSS. Can be either `ltr` or `rtl`.\n/// @type Keyword\n$global-text-direction: ltr !default;\n\n/// Enables flexbox for components that support it.\n/// @type Boolean\n$global-flexbox: true !default;\n\n/// Enabled responsive breakpoints for prototypes if applicable\n/// @type Boolean\n$global-prototype-breakpoints: false !default;\n\n/// Button cursor's value, `auto` by default\n/// @type Keyword\n$global-button-cursor: auto !default;\n\n@if not map-has-key($foundation-palette, primary) {\n  @error 'In $foundation-palette, you must have a color named \"primary\".';\n}\n\n// Internal variables used for text direction\n$global-left: if($global-text-direction == rtl, right, left);\n$global-right: if($global-text-direction == rtl, left, right);\n\n// Internal variable that contains the flex justifying options\n$-zf-flex-justify: -zf-flex-justify($global-text-direction);\n\n/// Global tolerance for color pick contrast.\n/// @type Number\n$global-color-pick-contrast-tolerance: 0 !default;\n\n// Internal variables used for colors\n@include add-foundation-colors;\n\n@mixin foundation-global-styles {\n  @include foundation-normalize;\n\n  // These styles are applied to a <meta> tag, which is read by the Foundation JavaScript\n  .foundation-mq {\n    font-family: '#{-zf-bp-serialize($breakpoints)}';\n  }\n\n  html {\n    box-sizing: border-box;\n    font-size: $global-font-size;\n  }\n\n  // Set box-sizing globally to handle padding and border widths\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  // Default body styles\n  body {\n    margin: 0;\n    padding: 0;\n\n    @if ($body-safe-padding) {\n      // using environment variables to account for non-rectangular displays e.g. phones with notches\n      padding-top: env(safe-area-inset-top);\n      padding-right: env(safe-area-inset-right);\n      padding-bottom: env(safe-area-inset-bottom);\n      padding-left: env(safe-area-inset-left);\n    }\n\n    background: $body-background;\n\n    font-family: $body-font-family;\n    font-weight: $global-weight-normal;\n    line-height: $global-lineheight;\n    color: $body-font-color;\n\n    @if ($body-antialiased) {\n      -webkit-font-smoothing: antialiased; // sass-lint:disable-line no-vendor-prefixes\n      -moz-osx-font-smoothing: grayscale; // sass-lint:disable-line no-vendor-prefixes\n    }\n  }\n\n  img {\n    // Get rid of gap under images by making them display: inline-block; by default\n    display: inline-block;\n    vertical-align: middle;\n\n    // Grid defaults to get images and embeds to work properly\n    max-width: 100%;\n    height: auto;\n    -ms-interpolation-mode: bicubic;\n  }\n\n  // Make sure textarea takes on height automatically\n  textarea {\n    height: auto;\n    min-height: 50px;\n    border-radius: $global-radius;\n  }\n\n  // Make select elements are 100% width by default\n  select {\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: $global-radius;\n  }\n\n  // Styles Google Maps and MapQuest embeds properly\n  // sass-lint:disable-line no-ids\n  .map_canvas,\n  .mqa-display {\n    img,\n    embed,\n    object {\n      max-width: none !important;\n    }\n  }\n\n  // Reset <button> styles created by most browsers\n  button {\n    @include disable-mouse-outline;\n    padding: 0;\n    appearance: none;\n    border: 0;\n    border-radius: $global-radius;\n    background: transparent;\n    line-height: 1;\n    cursor: $global-button-cursor;\n  }\n\n  // Prevent text overflow on pre\n  pre {\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  // Make reset inherit font-family instead of settings sans-serif\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n  }\n\n  // Internal classes to show/hide elements in JavaScript\n  .is-visible {\n    display: block !important;\n  }\n\n  .is-hidden {\n    display: none !important;\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Create gutters for a cell/container.\n///\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts either margin or padding.\n/// @param {List} $gutter-position [right left] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination.\n/// @param {Boolean} $negative [false] - Whether to apply the gutter as a negative value. Commonly used for nested grids.\n@mixin xy-gutters(\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: right left,\n  $negative: false\n) {\n  $operator: if($negative, '-', '');\n\n  // If we have declared negative gutters, force type to `margin.\n  $gutter-type: if($negative, 'margin', $gutter-type);\n\n  // Output our margin gutters.\n  @if (type-of($gutters) == 'map') {\n    @include -zf-breakpoint-value(auto, $gutters) {\n      $gutter: rem-calc($-zf-bp-value) * 0.5;\n\n      // Loop through each gutter position\n      @each $value in $gutter-position {\n        #{$gutter-type}-#{$value}: unquote(\"#{$operator}#{$gutter}\");\n      }\n    }\n  }\n  @else if (type-of($gutters) == 'number') {\n    $gutter: rem-calc($gutters) * 0.5;\n\n    // Loop through each gutter position\n    @each $value in $gutter-position {\n      #{$gutter-type}-#{$value}: unquote(\"#{$operator}#{$gutter}\");\n    }\n  }\n}\n","@import 'photoswipe/photoswipe.css';\n\n@import 'foundation-sites/scss/foundation.scss';\n\n@include foundation-xy-grid-classes;\n\n//masonry\n$masonry-css-column-gap: $global-margin;\n\n.masonry-grid {\n\n    .masonry-grid-item,\n    .grid-sizer {\n        @include breakpoint(small) {\n            width: 48.75%;\n        }\n\n        @include breakpoint(medium) {\n            width: 32.3333333%;\n        }\n\n        @include breakpoint(large) {\n            width: 23.882681575;\n        }\n\n        @include breakpoint(xlarge) {\n            width: 18.80819368%;\n        }\n\n        break-inside: avoid;\n        margin-bottom: $masonry-css-column-gap;\n        line-height: 0;\n        float: left;\n\n        img,\n        video {\n            display: block;\n            position: absolute;\n            top: 0;\n            max-width: 100%;\n        }\n\n        a {\n            width: 100%;\n            display: block;\n            cursor: pointer;\n        }\n    }\n\n    .gutter-sizer {\n        @include breakpoint(small) {\n            width: 2.5%;\n        }\n\n        @include breakpoint(medium) {\n            width: 1.5%;\n        }\n\n        @include breakpoint(large) {\n            width: 1.4897579%;\n        }\n    }\n\n    width: 100%;\n}\n\n\n.photoset-preview{\n    padding:10px;\n    margin-bottom:10px;\n    background-color: #eee;\n}\n\n\nbutton.pswp__button--share-button {\n    font-size: 18px;\n    color: #fff;\n  }\n\n//maybe migrate to photolead template\n#uicore-page #event-container, #uicore-page .single-image-view-container, #uicore-page .raffle-content {\n    padding-top: 50px;\n    @include breakpoint(medium) {\n        padding-top: 100px;\n    }\n    \n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n#uicore-page .single-image-view-box{\n    padding: 20px;\n    background-color: var(--e-global-color-uicore_light);\n\n    img{\n        display: block;\n        width: 100%;\n    }\n    .buttons {\n        padding-top: 20px;\n        display: flex;\n\n        div {\n            flex-grow: 1;\n            text-align: center;\n            flex-basis: 0;\n        }\n\n        i {\n            font-size: 25px;\n        }\n    }\n\n}\n.dayswellwasted{\n    padding: 50px;\n    background-color: #000;\n}\n#uicore-page .raffle{\n    input{\n        margin: 10px;\n    }\n}","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group breakpoints\n////\n\n/// Patch to fix issue #12080\n$-zf-size: null;\n\n/// A list of named breakpoints. You can use these with the `breakpoint()` mixin to quickly create media queries.\n/// @type Map\n$breakpoints: (\n  \"small\": 0,\n  \"medium\": 640px,\n  \"large\": 1024px,\n  \"xlarge\": 1200px,\n  \"xxlarge\": 1440px,\n) !default;\n\n/// A list of named HiDPI breakpoints. You can use these with the `breakpoint()` mixin to quickly create media queries for resolutions.\n/// Values must represent the device pixels / web pixels ration and be unitless or in DPPX.\n/// @type Map\n$breakpoints-hidpi: (\n  \"hidpi-1\": 1,\n  \"hidpi-1-5\": 1.5,\n  \"hidpi-2\": 2,\n  \"retina\": 2,\n  \"hidpi-3\": 3\n) !default;\n\n/// The largest named breakpoint in which to include print as a media type\n/// @type Keyword\n$print-breakpoint: large !default;\n\n$-zf-zero-breakpoint: small !default;\n\n$-zf-breakpoints-keys: map-to-list($breakpoints, 'keys');\n\n@if nth(map-values($breakpoints), 1) != 0 {\n  @error 'The first key in the $breakpoints map must have a value of \"0\".';\n}\n@else {\n  $-zf-zero-breakpoint: nth(map-keys($breakpoints), 1);\n}\n\n/// All of the names in this list will be output as classes in your CSS, like `.small-12`, `.medium-6`, and so on. Each value in this list must also be in the `$breakpoints` map.\n/// @type List\n$breakpoint-classes: (small medium large) !default;\n\n/// Generates a media query string matching the input value. Refer to the documentation for the `breakpoint()` mixin to see what the possible inputs are.\n///\n/// @param {Keyword|Number} $val [small] - Breakpoint name, or px, rem, or em value to process.\n@function breakpoint($val: $-zf-zero-breakpoint) {\n  // Web standard Pixels per inch. (1ddpx / $std-web-dpi) = 1dpi\n  // See https://www.w3.org/TR/css-values-3/#absolute-lengths\n  $std-web-dpi: 96;\n\n  // Size or keyword\n  $bp: nth($val, 1);\n  // Value of the following breakpoint\n  $bp-next: null;\n  // Value for max-width media queries\n  $bp-min: null;\n  // Value for min-width media queries\n  $bp-max: null;\n  // Direction of media query (up, down, or only)\n  $dir: if(length($val) > 1, nth($val, 2), up);\n  // If named, name of the breakpoint\n  $name: null;\n  // If the breakpoint is a HiDPI breakpoint\n  $hidpi: false;\n\n  // Orientation media queries have a unique syntax\n  @if $bp == 'landscape' or $bp == 'portrait' {\n    @return '(orientation: #{$bp})';\n  }\n\n  // If a breakpoint name is given, get its value from the $breakpoints/$breakpoints-hidpi map.\n  @if type-of($bp) == 'string' {\n    @if map-has-key($breakpoints, $bp) {\n      $name: $bp;\n      $bp: map-get($breakpoints, $name);\n      $bp-next: -zf-map-next($breakpoints, $name);\n    }\n    @else if map-has-key($breakpoints-hidpi, $bp) {\n      $name: $bp;\n      $bp: map-get($breakpoints-hidpi, $name);\n      $bp-next: -zf-map-next-number($breakpoints-hidpi, $bp);\n      $hidpi: true;\n    }\n    @else {\n      $bp: 0;\n      @warn 'breakpoint(): \"#{$val}\" is not defined in your `$breakpoints` or `$breakpoints-hidpi` setting.';\n    }\n  }\n\n  @if not $name and $dir == 'only' {\n    @warn 'breakpoint(): Only named media queries can have an `only` range.';\n    @return null;\n  }\n\n  // Only 'only' and 'up' have a min limit.\n  @if $dir == 'only' or $dir == 'up' {\n    $bp-min: if($hidpi, strip-unit($bp), -zf-bp-to-em($bp));\n  }\n  // Only 'only' and 'down' have a max limit.\n  @if $dir == 'only' or $dir == 'down' {\n    // If the breakpoint is a value, use it as max limit.\n    @if not $name {\n      $bp-max: if($hidpi, strip-unit($bp), -zf-bp-to-em($bp));\n    }\n    // If the breakpoint is named, the max limit is the following breakpoint - 1px.\n    @else if $bp-next {\n      // Max value is 0.2px under the next breakpoint (0.02 / 16 = 0.00125).\n      // Use a precision under 1px to support browser zoom, but not to low to avoid rounding.\n      // See https://github.com/foundation/foundation-sites/issues/11313\n      $bp-max: if($hidpi, $bp-next - divide(1, $std-web-dpi), -zf-bp-to-em($bp-next) - 0.00125);\n    }\n  }\n\n  // Generate the media query string from min and max limits.\n  @if $hidpi {\n    // Generate values in DPI instead of DPPX for an IE9-11/Opera mini compatibility.\n    // See https://caniuse.com/#feat=css-media-resolution\n    $bp-min-dpi: if($bp-min, $bp-min * $std-web-dpi * 1dpi, $bp-min);\n    $bp-max-dpi: if($bp-max, $bp-max * $std-web-dpi * 1dpi, $bp-max);\n    @return zf-str-join(\n      -zf-bp-join($bp-min, $bp-max, '-webkit-min-device-pixel-ratio', '-webkit-max-device-pixel-ratio'),\n      -zf-bp-join($bp-min-dpi, $bp-max-dpi, 'min-resolution', 'max-resolution'),\n      ', ');\n  }\n  @else {\n    @return -zf-bp-join($bp-min, $bp-max);\n  }\n}\n\n/// Wraps a media query around the content you put inside the mixin. This mixin accepts a number of values:\n///  - If a string is passed, the mixin will look for it in the `$breakpoints` and `$breakpoints-hidpi` maps, and use a media query there.\n///  - If a pixel value is passed, it will be converted to an em value using `$global-font-size` as the base.\n///  - If a rem value is passed, the unit will be changed to em.\n///  - If an em value is passed, the value will be used as-is.\n///\n/// If multiple values are passed, the mixin will generate a media query for each of them as described above.\n/// Since the content is duplicated for each breakpoint, this mixin should only be used with properties that\n/// change across breakpoints.\n///\n/// @param {Keyword|Number} $values... - Breakpoint name or px/rem/em value to process.\n///\n/// @output If the breakpoint is \"0px and larger\", outputs the content as-is. Otherwise, outputs the content wrapped in a media query.\n@mixin breakpoint($values...) {\n  @for $i from 1 through length($values) {\n    $value: nth($values, $i);\n    $str: breakpoint($value);\n    $bp: index($-zf-breakpoints-keys, nth($value, 1));\n    $pbp: index($-zf-breakpoints-keys, $print-breakpoint);\n    // Direction of media query (up, down, or only)\n    $dir: if(length($value) > 1, nth($value, 2), up);\n\n    $old-zf-size: null;\n\n    // Make breakpoint size available as a variable\n    @if global-variable-exists(-zf-size) {\n      $old-zf-size: $-zf-size;\n    }\n    $-zf-size: nth($value, 1) !global; // get the first value to account for `only` and `down` keywords\n\n    // If $str is still an empty string, no media query is needed\n    @if $str == '' {\n      @content;\n    }\n\n    // Otherwise, wrap the content in a media query\n    @else {\n      // For named breakpoints less than or equal to $print-breakpoint, add print to the media types\n      // generate print if the breakpoint affects the print-breakpoint (or smaller).\n      // This means the current condition only needs to be extended so 'down' always generates print.\n      @if $bp != null and ($bp <= $pbp or $dir == down) {\n        @media print, screen and #{$str} {\n          @content;\n        }\n      }\n      @else {\n        @media screen and #{$str} {\n          @content;\n        }\n      }\n    }\n\n    $-zf-size: $old-zf-size !global;\n  }\n}\n\n/// Converts the breakpoints map to a URL-encoded string, like this: `key1=value1&key2=value2`. The value is then dropped into the CSS for a special `<meta>` tag, which is read by the Foundation JavaScript. This is how we transfer values from Sass to JavaScript, so they can be defined in one place.\n/// @access private\n///\n/// @param {Map} $map - Map to convert.\n///\n/// @returns {String} A string containing the map's contents.\n@function -zf-bp-serialize($map) {\n  $str: '';\n  @each $key, $value in $map {\n    $str: $str + $key + '=' + -zf-bp-to-em($value) + '&';\n  }\n  $str: str-slice($str, 1, -2);\n\n  @return $str;\n}\n\n/// Find the next key in a map.\n/// @access private\n///\n/// @param {Map} $map - Map to traverse.\n/// @param {Mixed} $key - Key to use as a starting point.\n///\n/// @returns {Mixed} The value for the key after `$key`, if `$key` was found. If `$key` was not found, or `$key` was the last value in the map, returns `null`.\n@function -zf-map-next($map, $key) {\n\n  // Store the keys of the map as a list\n  $values: map-keys($map);\n\n  $i: 0;\n\n  // If the Key Exists, Get the index of the key within the map and add 1 to it for the next breakpoint in the map\n  @if (map-has-key($map, $key)) {\n    $i: index($values, $key) + 1;\n  }\n\n  // If the key doesn't exist, or it's the last key in the map, return null\n  @if ($i > length($map) or $i == 0) {\n    @return null;\n  }\n  // Otherwise, return the value\n  @else {\n    @return map-get($map, nth($values, $i));\n  }\n\n}\n\n/// Find the next number in a map.\n/// @access private\n///\n/// @param {Map} $map - Map to traverse.\n/// @param {Mixed} $number - Number to use as a starting point.\n///\n/// @returns {Mixed} The number following `$number`, if `$number` was found. If `$number` was not found, or `$number` was the biggest number in the map, returns `null`.\n@function -zf-map-next-number($map, $number) {\n\n  $next-number: null;\n\n  @each $k, $v in $map {\n    @if type-of($v) == 'number' and $v > $number and ($next-number == null or $v < $next-number) {\n      $next-number: $v;\n    }\n  }\n\n  @return $next-number;\n}\n\n/// Return a list of our named breakpoints less than $key. Useful for dealing with\n/// responsive gutters for the grid.\n/// @access private\n///\n/// @param {String} $key - Key to use as last breakpoint.\n///\n/// @returns {Array} The list of breakpoints up to and. If $key is auto, returns breakpoints above the zero\n@function -zf-breakpoints-less-than($key) {\n  $list: ();\n  $found-key: false;\n\n  @each $name in $-zf-breakpoints-keys {\n    @if ($name == $key) {\n      $found-key: true;\n    }\n    @if not $found-key {\n      $list: append($list, $name);\n    }\n  }\n  @return $list;\n}\n\n/// Return a list of our named breakpoints less than $key. Useful for dealing with\n/// responsive gutters for the grid.\n/// @access private\n///\n/// @param {String} $breakpoint - a named or non-named breakpoint.\n///\n/// @returns {Array} The list of breakpoints up to and. If $key is auto, returns breakpoints above the zero\n@function -zf-closest-named-breakpoint($breakpoint) {\n  $last: $-zf-zero-breakpoint;\n  $found: false;\n\n  $value: unitless-calc($breakpoint, 1px);\n  @each $key, $val in $breakpoints {\n    @if not $found {\n      @if unitless-calc($val) > $value {\n        $found: true;\n      } @else {\n        $last: $key;\n      }\n    }\n  }\n\n  @return $last;\n}\n\n/// Get a value for a breakpoint from a responsive config map or single value.\n/// - If the config is a single value, return it regardless of `$value`.\n/// - If the config is a map and has the key `$value`, the exact breakpoint value is returned.\n/// - If the config is a map and does *not* have the breakpoint, the value matching the next lowest breakpoint in the config map is returned.\n/// @access private\n///\n/// @param {Number|Map} $map - Responsive config map or single value.\n/// @param {Keyword} $value - Breakpoint name to use.\n///\n/// @return {Mixed} The corresponding breakpoint value.\n@function -zf-get-bp-val($map, $value) {\n  // If the given map is a single value, return it\n  @if type-of($map) == 'number' {\n    @return $map;\n  }\n\n\n  // Check if the breakpoint name exists globally\n  @if not map-has-key($breakpoints, $value) {\n    @if type-of($value) == 'number' {\n      $value: -zf-closest-named-breakpoint($value);\n    } @else {\n      @return null;\n    }\n  }\n  // Check if the breakpoint name exists in the local config map\n  @else if map-has-key($map, $value) {\n    // If it does, just return the value\n    @return map-get($map, $value);\n  }\n  // Otherwise, find the next lowest breakpoint and return that value\n  @else {\n    $anchor: null;\n    $found: false;\n\n    @each $key, $val in $breakpoints {\n      @if not $found {\n        @if map-has-key($map, $key) {\n          $anchor: $key;\n        }\n        @if $key == $value {\n          $found: true;\n        }\n      }\n    }\n\n    @return map-get($map, $anchor);\n  }\n}\n\n/// Return the best breakpoint to use according to the calling context. It returns in order:\n/// 1. the given `$value` argument if it is not null.\n/// 2. the global breakpoint context `$-zf-size` if it is not null (like if called inside then `breakpoint()` mixin)\n/// 3. the given `$default` argument.\n/// @access private\n///\n/// @param {Keyword} $value [null] - Breakpoint to use in priority if non-null.\n/// @param {Keyword} $default [null] - Breakpoint to use by default if no other value can be used.\n///\n/// @return {Keyword} The resolved breakpoint.\n@function -zf-current-breakpoint($value: null, $default: null) {\n  @if ($value != null) {\n    @return $value;\n  }\n  @else if (variable-exists(-zf-size) and type-of($-zf-size) != 'number') and $-zf-size != null {\n    @return $-zf-size;\n  }\n  @else {\n    @return $default;\n  }\n}\n\n/// Return media query string from the given min and/or max limits.\n/// If a limit is equal to `null` or `0`, it is ignored.\n/// @access private\n///\n/// @param {Number} $min [0] - Min media query limit.\n/// @param {Number} $max [0] - Max media query limit.\n/// @param {String} $min-name ['min-width'] - Name of the min media query limit.\n/// @param {String} $delimiter ['max-width'] - Name of the max media query limit.\n///\n/// @returns {String} Media Query string.\n@function -zf-bp-join(\n  $min: 0,\n  $max: 0,\n  $min-name: 'min-width',\n  $max-name: 'max-width'\n) {\n  @return zf-str-join(\n    if($min and $min > 0, '(#{$min-name}: #{$min})', null),\n    if($max and $max > 0, '(#{$max-name}: #{$max})', null),\n    ' and ');\n}\n\n$small-up: '';\n$small-only: '';\n\n@if map-has-key($breakpoints, small) {\n  $small-up: screen;\n  $small-only: unquote('screen and #{breakpoint(small only)}');\n}\n\n$medium-up: '';\n$medium-only: '';\n\n@if map-has-key($breakpoints, medium) {\n  $medium-up: unquote('screen and #{breakpoint(medium)}');\n  $medium-only: unquote('screen and #{breakpoint(medium only)}');\n}\n\n$large-up: '';\n$large-only: '';\n\n@if map-has-key($breakpoints, large) {\n  $large-up: unquote('screen and #{breakpoint(large)}');\n  $large-only: unquote('screen and #{breakpoint(large only)}');\n}\n\n$xlarge-up: '';\n$xlarge-only: '';\n\n@if map-has-key($breakpoints, xlarge) {\n  $xlarge-up: unquote('screen and #{breakpoint(xlarge)}');\n  $xlarge-only: unquote('screen and #{breakpoint(xlarge only)}');\n}\n\n$xxlarge-up: '';\n\n@if map-has-key($breakpoints, xxlarge) {\n  $xxlarge-up: unquote('screen and #{breakpoint(xxlarge)}');\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Returns the appropriate CSS flex value for a cell base.\n///\n/// @param {Keyword} $size [full] - The size of your cell. Accepts `full`, `auto`, `shrink`, `grow`, or any other value representing a cell size (it will be treated as `shrink`).\n///\n/// @returns {List} The cell flex property value.\n@function xy-cell-base($size: full) {\n  @if ($size == 'auto') {\n    @return 1 1 0;\n  }\n  @else if ($size == 'grow') {\n    @return 1 0 auto;\n  }\n  @else if ($size == 'shrink' or $size == 'full' or zf-is-fraction($size, $allow-no-denominator: true)) {\n    @return 0 0 auto;\n  }\n  @return null;\n}\n\n/// Calculate the size of a cell gutters.\n///\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, returns the responsive gutters map `$gutters`. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n///\n/// @returns {Number|Map} The cell gutter size or the responsive gutters map.\n@function xy-cell-gutters(\n  $gutters: $grid-margin-gutters,\n  $breakpoint: null\n) {\n  // For `auto`, returns the responsive map `$gutters`.\n  @if ($breakpoint == 'auto') {\n    @return $gutters;\n  }\n\n  // Use the contextual breakpoint by default.\n  $breakpoint: -zf-current-breakpoint($breakpoint);\n\n  @if ($breakpoint) {\n    @return -zf-get-bp-val($gutters, $breakpoint);\n  }\n  @else {\n    @return -zf-get-bp-val($gutters, $-zf-zero-breakpoint) or 0;\n  }\n}\n\n/// Returns the percentage size of a cell.\n///\n/// @param {Number|List} $size [$grid-columns] - Size to make the cell. You can pass a value in multiple formats, such as `6`, `50%`, `1 of 2` or `1/3`.\n///\n/// @returns {Number} Size of the cell (in percent).\n@function xy-cell-size(\n  $size: $grid-columns\n) {\n  @return fraction-to-percentage($size, $denominator: $grid-columns);\n}\n\n/// Returns the appropriate CSS value for a cell size.\n///\n/// Gutters-related arguments are required for cells with margin gutters (by default) as the gutter is included in the width.\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full`, `auto`, `shrink` or any fraction like `6`, `50%`, `1 of 2` or `1/2`.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, returns a map of sizes adapted to responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n///\n/// @returns {Number|String|Map} The cell sizing property value, or a responsive map of them.\n@function xy-cell-size-css(\n  $size: full,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null\n) {\n  $margin-gutter: 0;\n\n  @if ($size == 'auto' or $size == 'shrink') {\n    @return auto;\n  }\n\n  // For cells with margin gutters, the gutter is included in the width.\n  @if ($gutter-type == 'margin') {\n    $margin-gutter: xy-cell-gutters($gutters, $breakpoint);\n    @if ($margin-gutter == null) {\n      @error 'xy-cell-size: no gutters were found in `$gutters` for \"$breakpoint: #{$breakpoint}\"';\n    }\n  }\n\n  // Calculate the cell size (number)\n  $size-raw: if($size == 'full', 100%, xy-cell-size($size));\n\n  // Calculate the cell CSS size including gutters (string)\n  // If the cell has responsive margin gutters, return a responsive map of sizes.\n  @if type-of($margin-gutter) == 'map' {\n    $responsive-css-sizes: ();\n\n    @each $bp, $mg in $margin-gutter {\n      $mgc: rem-calc($mg);\n      @if $mgc == 0 {\n        // sass-lint:disable zero-unit\n        $mgc: 0rem;\n      }\n      $size-css: if($mg == 0, $size-raw, calc(#{$size-raw} - #{$mg}));\n      $responsive-css-sizes: map-merge($responsive-css-sizes, ($bp: $size-css));\n    }\n\n    @return $responsive-css-sizes;\n  }\n  // Otherwise, return a single CSS size.\n  @else {\n    // Make sure that 0 is translated in 0rem for calc()\n    $mgc: rem-calc($margin-gutter);\n    @if $mgc == 0 {\n      // sass-lint:disable zero-unit\n      $mgc: 0rem;\n    }\n    $css-size: if($margin-gutter == 0, $size-raw, calc(#{$size-raw} - #{$mgc}));\n    @return $css-size;\n  }\n}\n\n/// Sets base flex properties for cells.\n///\n/// @param {Keyword} $size [full] - The size of your cell. Accepts `full`, `auto`, `shrink`, `grow`, or any other value representing a cell size (it will be treated as `shrink`).\n@mixin xy-cell-base($size: full) {\n  $base: xy-cell-base($size);\n\n  flex: #{$base};\n\n  // Set base styles for \"full\" only\n  @if($size == 'full') {\n    min-height: 0;\n    min-width: 0;\n  }\n}\n\n/// Resets a cells width (or height if vertical is true) as well as strips its gutters.\n///\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n@mixin xy-cell-reset($vertical: true) {\n  $direction: if($vertical == true, height, width);\n  #{$direction}: auto;\n  max-#{$direction}: none;\n}\n\n/// Sets sizing properties for cells.\n///\n/// Gutters-related arguments are required for cells with margin gutters (by default) as the gutter is included in the width.\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full` (100% width), `auto` (use all available space), `shrink` (use only the required space) or any fraction (`6`, `50%`, `1 of 2` or `1/2`...).\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, generates sizes adapted for responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n@mixin xy-cell-size(\n  $size: full,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null,\n  $vertical: false\n) {\n  $sizes: xy-cell-size-css($size, $gutters, $gutter-type, $breakpoint);\n  $direction: if($vertical == true, height, width);\n\n  @if (type-of($sizes) == 'map') {\n    @include -zf-breakpoint-value(auto, $sizes) {\n      #{$direction}: $-zf-bp-value;\n    }\n  }\n  @else {\n    #{$direction}: $sizes;\n  }\n}\n\n/// Sets gutters properties for cells.\n///\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {List} $gutter-position [null] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination. By default `right left` for horizontal cells and `top bottom` for vertical cells.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, generates responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Direction of the gutters to output. See `$gutter-position`.\n@mixin xy-cell-gutters(\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: null,\n  $breakpoint: null,\n  $vertical: false\n) {\n  // Get the default gutter position according to cell direction\n  @if($gutter-position == null) {\n    $gutter-position: if($vertical == true, top bottom, left right);\n  }\n\n  // Get the gutter width for this breakpoint\n  $gutter-width: xy-cell-gutters($gutters, $breakpoint);\n  @if ($gutter-width == null) {\n    @error 'xy-cell-gutters: no gutters were found in `$gutters` for \"$breakpoint: #{$breakpoint}\"';\n  }\n\n  @if ($gutter-type and $gutter-type != none) {\n    @include xy-gutters($gutter-width, $gutter-type, $gutter-position);\n  }\n}\n\n/// Creates a cell for your grid.\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full` (100% width), `auto` (use all available space), `shrink` (use only the required space) or any fraction (`6`, `50%`, `1 of 2` or `1/2`...).\n/// @param {Boolean} $gutter-output [null] - [DEPRECATED] Whether or not to output gutters.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {List} $gutter-position [null] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination. By default `right left` for horizontal cells and `top bottom` for vertical cells.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If `auto`, generates responsive gutters. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n/// @param {List} $output [(base size gutters)] - Cell parts to output. You will need to generate others parts of the cell seperately, it may not work properly otherwise.\n@mixin xy-cell(\n  $size: full,\n  $gutter-output: null,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: null,\n  $breakpoint: null,\n  $vertical: false,\n  $output: (base size gutters)\n) {\n  // Default for $gutter-output\n  @if ($gutter-output != null) {\n    @warn 'xy-cell: $gutter-output is deprecated and will be removed. See migration notes at https://git.io/foundation-6-6-0';\n    @if ($gutter-output == false) {\n      $output: sl-remove($output, gutters);\n    }\n  }\n\n  @if (index($output, base)) {\n    @include xy-cell-base($size);\n  }\n  @if (index($output, size)) {\n    @include xy-cell-size($size, $gutters, $gutter-type, $breakpoint, $vertical);\n  }\n  @if (index($output, gutters)) {\n    @include xy-cell-gutters($gutters, $gutter-type, $gutter-position, $breakpoint, $vertical);\n  }\n}\n\n/// Creates a single breakpoint sized grid. Used to generate our grid classes.\n///\n/// `xy-cell-static()` is deprecated and will be removed.\n/// Use `xy-cell()` instead with `$output: (size gutters)` to not generate the cell base.\n/// See migration notes at https://git.io/foundation-6-6-0\n///\n/// @deprecated v6.6.0\n///\n/// @param {Keyword|Number} $size [full] - The size of your cell. Can be `full` (100% width), `auto` (use all available space), `shrink` (use only the required space) or any fraction (`6`, `50%`, `1 of 2` or `1/2`...).\n/// @param {Boolean} $gutter-output [true] - Whether or not to output gutters. Always `true` for margin gutters.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Map or single value for gutters.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n@mixin xy-cell-static(\n  $size: full,\n  $gutter-output: true,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: $-zf-zero-breakpoint,\n  $vertical: false\n) {\n  @warn 'xy-cell-static() mixin is deprecated and will be removed. Use \"xy-cell()\" instead. See migration notes at https://git.io/foundation-6-6-0';\n\n  $gutter: -zf-get-bp-val($gutters, $breakpoint);\n  $gutter-position: if($vertical == true, top bottom, left right);\n\n  $-gutter-output: if($gutter-type == 'margin', true, $gutter-output);\n  $-gutter-margin: if($gutter-type == 'margin', $gutter, 0);\n\n  @include -xy-cell-properties($size, $-gutter-margin, $vertical);\n  @if ($-gutter-output) {\n    @include xy-gutters($gutter, $gutter-type, $gutter-position);\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Sizes child elements so that `$n` number of items appear on each row.\n///\n/// @param {Number} $n - Number of elements to display per row.\n/// @param {String} $selector ['.cell'] - Selector(s) to use for child elements.\n/// @param {Boolean} $gutter-output [null] - [DEPRECATED] Whether or not to output gutters.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] - Map or single value for gutters.\n/// @param {Keyword} $gutter-type [margin] - Type of gutter to output. Accepts `margin`, `padding` or `none`.\n/// @param {List} $gutter-position [null] - The position to apply gutters to. Accepts `top`, `bottom`, `left`, `right` in any combination. By default `right left` for horizontal cells and `top bottom` for vertical cells.\n/// @param {String} $breakpoint [null] - The breakpoint to use for the cell generation. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] - Set to true to output vertical (height) styles rather than widths.\n/// @param {List} $output [(base size gutters)] - Cell parts to output. You will need to generate others parts of the cell seperately, it may not work correctly otherwise.\n@mixin xy-grid-layout(\n  $n,\n  $selector: '.cell',\n  $gutter-output: null,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $gutter-position: null,\n  $breakpoint: null,\n  $vertical: false,\n  $output: (base size gutters)\n) {\n  $size: percentage(divide(1, $n));\n\n  & > #{$selector} {\n    @include xy-cell($size, $gutter-output, $gutters, $gutter-type, $gutter-position, $breakpoint, $vertical, $output);\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Collapses the grid a cells within it.\n///\n/// @param {String} $selector [.cell] - The child element to remove the gutter from.\n/// @param {Keyword} $gutter-type [margin] - The type of gutter to remove.\n/// @param {List} $gutter-position [right left] - The positions to remove gutters from. Accepts `top`, `bottom`, `left`, `right` in any combination.\n/// @param {Keyword} $min-breakpoint [$-zf-zero-breakpoint] - Minimum breakpoint in `$breakpoint-classes` for which to collapse the gutter.\n@mixin xy-grid-collapse(\n  $selector: '.cell',\n  $gutter-type: margin,\n  $gutter-position: right left,\n  $min-breakpoint: $-zf-zero-breakpoint\n) {\n  // First, lets negate any margins on the top level\n  @if ($gutter-type == 'margin') {\n\n    @include breakpoint($min-breakpoint) {\n      @each $value in $gutter-position {\n        margin-#{$value}: 0;\n      }\n\n      > #{$selector} {\n        @each $value in $gutter-position {\n          margin-#{$value}: 0;\n        }\n      }\n    }\n\n    $excluded-bps: -zf-breakpoints-less-than($min-breakpoint);\n\n    // Output new widths to not include gutters\n    @each $bp in $breakpoint-classes {\n      @if(sl-contain($excluded-bps, $bp)) {\n        @include breakpoint($min-breakpoint) {\n          @for $i from 1 through $grid-columns {\n            // Sizing (percentage)\n            > .#{$bp}-#{$i} {\n              @include xy-cell-size($i, $gutter-type: none);\n            }\n          }\n        }\n      } @else {\n        @include breakpoint($bp) {\n          @for $i from 1 through $grid-columns {\n            // Sizing (percentage)\n            > .#{$bp}-#{$i} {\n              @include xy-cell-size($i, $gutter-type: none);\n            }\n          }\n        }\n      }\n    }\n  }\n  @else {\n\n    @include breakpoint($min-breakpoint) {\n      @each $value in $gutter-position {\n        margin-#{$value}: 0;\n      }\n\n      > #{$selector} {\n        @each $value in $gutter-position {\n          padding-#{$value}: 0;\n        }\n      }\n    }\n  }\n}\n","// Foundation for Sites\n// https://get.foundation\n// Licensed under MIT Open Source\n\n////\n/// @group xy-grid\n////\n\n/// Returns the appropriate CSS value to offset a cell.\n///\n/// @param {Number|List} $n - Size to offset by. You can pass in any value accepted by the `xy-cell()` mixin, such as `6`, `50%`, or `1 of 2`.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] Map of gutters or single value to use for responsive gutters.\n/// @param {Keyword} $gutter-type [margin] The type of gutter to use. Can be `margin` or `padding`\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n///\n/// @returns {Number|String} The cell offset property value.\n@function xy-cell-offset(\n  $n,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null\n) {\n  $breakpoint: -zf-current-breakpoint($breakpoint, $default: $-zf-zero-breakpoint);\n  $size: xy-cell-size($n);\n\n  $offset: $size;\n  @if ($gutter-type == 'margin') {\n    // Make sure that 0 is translated in 0rem for calc()\n    $gutter: rem-calc(xy-cell-gutters($gutters, $breakpoint));\n    @if $gutter == 0 {\n      // sass-lint:disable zero-unit\n      $gutter: 0rem;\n    }\n    $offset: if($gutter == 0, $size, calc(#{$size} + #{$gutter} / 2));\n  }\n  @return $offset;\n}\n\n/// Offsets a column to the right/bottom by `$n` columns.\n///\n/// @param {Number|List} $n - Size to offset by. You can pass in any value accepted by the `xy-cell()` mixin, such as `6`, `50%`, or `1 of 2`.\n/// @param {Number|Map} $gutters [$grid-margin-gutters] Map of gutters or single value to use for responsive gutters.\n/// @param {Keyword} $gutter-type [margin] The type of gutter to use. Can be `margin` or `padding`\n/// @param {Number|Array|Keyword} $breakpoint [null] - Breakpoint to use for `$gutters`. It can be a breakpoint name, list of breakpoints or `auto` for all breakpoints. If a list is given, media-queries will be generated. If using with the `breakpoint()` mixin this will be set automatically unless manually entered.\n/// @param {Boolean} $vertical [false] Sets the direction of the offset. If set to true will apply margin-top instead.\n@mixin xy-cell-offset(\n  $n,\n  $gutters: $grid-margin-gutters,\n  $gutter-type: margin,\n  $breakpoint: null,\n  $vertical: false\n) {\n  $breakpoint: -zf-current-breakpoint($breakpoint, $default: $-zf-zero-breakpoint);\n  $direction: if($vertical, 'top', $global-left);\n\n  @include -zf-each-breakpoint-in($breakpoint, $media-queries: 'for-lists') {\n    $offset: xy-cell-offset($n, $gutters, $gutter-type);\n    margin-#{$direction}: #{$offset};\n  }\n}\n","// sass-lint:disable no-vendor-prefixes\n\n/// Modifies a grid to give it \"frame\" behavior (no overflow, no wrap, stretch behavior)\n///\n/// @param {Boolean} $vertical [false] - Is grid vertical or horizontal. Should match grid.\n/// @param {Boolean} $nested [false] - Is grid nested or not. If nested is true this sets the frame to 100% height, otherwise will be 100vh.\n/// @param {Number|Map} $gutters [null] - Map or single value for gutters.\n/// @param {String} $breakpoint [null] - The name of the breakpoint size in your gutters map to get the size from.\n/// @param {Boolean} $include-base [true] - Include the base styles that don't vary per breakpoint.\n@mixin xy-grid-frame(\n  $vertical: false,\n  $nested: false,\n  $gutters: null,\n  $breakpoint: null,\n  $include-base: true\n) {\n\n  @if $include-base {\n    overflow: hidden;\n    position: relative;\n    flex-wrap: nowrap;\n    align-items: stretch;\n  }\n\n  @if $breakpoint == null and type-of($gutters) == 'map' {\n    @include -zf-each-breakpoint() {\n      @include xy-grid-frame($vertical, $nested, $gutters, $-zf-size, false);\n    }\n  } @else {\n    // Get our gutters if applicable\n    $gutter: -zf-get-bp-val($gutters, $breakpoint);\n\n    // If we have a gutter, add it to the width/height\n    @if $gutter {\n      @if $vertical == true {\n        $unit: if($nested == true, 100%, 100vh);\n        $gutter: rem-calc($gutter);\n        // Make sure that 0 is translated in 0rem for calc()\n        @if $gutter == 0 {\n          // sass-lint:disable zero-unit\n          $gutter: 0rem;\n        }\n        height: calc(#{$unit} + #{$gutter});\n      } @else {\n        $unit: if($nested == true, 100%, 100vw);\n        $gutter: rem-calc($gutter);\n        // Make sure that 0 is translated in 0rem for calc()\n        @if $gutter == 0 {\n          // sass-lint:disable zero-unit\n          $gutter: 0rem;\n        }\n        width: calc(#{$unit} + #{$gutter});\n      }\n    }\n    @else {\n      @if $vertical == true {\n        height: if($nested == true, 100%, 100vh);\n      } @else {\n        width: if($nested == true, 100%, 100vw);\n      }\n    }\n  }\n}\n\n/// Modifies a cell to give it \"block\" behavior (overflow auto, inertial scrolling)\n///\n/// @param {Boolean} $vertical [false] - Is grid vertical or horizontal. Should match grid.\n@mixin xy-cell-block(\n  $vertical: false\n) {\n  $property: if($vertical == true, 'overflow-y', 'overflow-x');\n\n  @if $vertical == true {\n    overflow-y: auto;\n    max-height: 100%;\n    min-height: 100%;\n  } @else {\n    overflow-x: auto;\n    max-width: 100%;\n  }\n\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n\n/// Container for inside a grid frame containing multiple blocks. Typically used\n/// as a modifier for a `.cell` to allow the cell to pass along flex sizing\n/// constraints / from parents to children.\n@mixin xy-cell-block-container() {\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n\n  > .grid-x {\n    max-height: 100%;\n    flex-wrap: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
